import { LOCALES } from '../../utils/i18n/constants'

export default {
  [LOCALES.SPANISH]: {
    't_aas': 'Todas las superficies',
    't_parent_fund': '(ES Parent fund)',
    't_account_locked': 'Cuenta bloqueada',
    't_action': 'Acción',
    't_horizontal_artificial': 'ES Horizontal artificial',
    't_vertical_artificial': 'ES Vertical artificial',
    't_horizontal_artificial_areas': 'ES Horizontal artificial areas',
    't_vertical_artificial_areas': 'ES Vertical artificial areas',
    't_generic_number_message': 'ES {field} must be a number',
    't_generic_positivenumber_message': 'ES {field} must be a positive number',
    't_horizontal_artificial_less_than_total_message': 'ES Horizontal artificial cannot be greater than the total horizontal area',
    't_vertical_artificial_less_than_total_message': 'ES Vertical artificial cannot be greater than the total vertical area',
    't_planning_permission_date_before_purchase': 'ES Must be before the year the asset was built (see Asset Details)',
    't_action_error_message': 'Por favor, corrige los elementos señalados en rojo',
    't_action_excel': 'SIERA Plan de Acción.xlsx',
    't_action_pdf': 'SIERA Plan de Acción.pdf',
    't_action_plan': 'Plan de acción',
    't_reports_resource_consumption_not_found_msg': 'ES {areas}cannot be empty if current status is Major Renovation or New Construction.',
    't_sustainableweight_not_found_msg': 'ES {areas} cannot be empty.',
    't_totalweight_not_found_msg': 'ES {areas} cannot be empty.',
    't_startdate_not_found_msg': 'ES {areas} cannot be empty.',
    't_enddate_not_found_msg': 'ES {areas} cannot be empty.',
    't_reports_sustainableweight_not_found': 'ES Sustainable Weight',
    't_reports_totalweight_not_found': 'ES Total Weight',
    't_reports_startdate_not_found': 'ES Start Date',
    't_reports_enddate_not_found': 'ES End Date',
    't_sustainable_tonnes': 'ES Sustainable tonnes',
    't_total_tonnes': 'ES Total tonnes',
    't_exposure_select': 'ES Select Exposure',
    't_report_data_checklist': 'ES Report data checklist',
    't_planning_permission': 'ES Planning Permission',
    't_periodic_reporting_data': 'ES Periodic reporting data',
    't_waste_contracts': 'ES Waste Contracts',
    't_report_data_checklist_info': 'ES Select a reporting framework to highlight data readiness issues.',
    't_action_completion_dates': 'Se acercan las fechas de finalización de las acciones',
    't_biodiversity_extended': 'ES Indicate the total surface areas of the building, and the portion of these surface areas which is non-vegetated.',
    't_occupancy_extended': 'ES Track the proportion of lettable floor area occupied over time.',
    't_planning_permission_extended': 'ES Indicate the date the asset received planning permission. This is used to determine the energy efficiency standards the building must meet.',
    't_fossil_fuel_exposure_extended_edit_data': 'ES Track whether the asset is involved in the extraction, transport, storage or manufacture of fossil fuels. This status should be confirmed quarterly.',
    't_ped_extended': 'ES Indicate the Primary Energy Demand (PED) of the asset, and the Nearly Zero-Energy Building (NZEB) Threshold against which this is compared, if applicable.',
    't_gav_extended': 'ES Track the gross value of the asset.',
    't_waste_contracts_extended': 'ES Track whether the asset is equipped with facilities for waste sorting and covered by a waste recovery or recycling contract.',
    't_resource_consumption_extended': 'ES If development work occurred, indicate the total tonnes of raw materials used, the amount which was sustainably sourced, and the project period. Otherwise, leave this blank.',
    't_actions': 'Acciones',
    't_actions_under_review': 'Acciones en revisión',
    't_actual': 'Actual',
    't_grey': 'Sin cobertura',
    't_add_action': 'Agregar acción',
    't_no_action_data': 'No hay acciones para mostrar',
    't_add_an_action': 'Agregar una acción',
    't_add_action_title': 'Agregar título de la acción',
    't_add_date': 'Añadir fecha',
    't_add_note': 'Agregar una nota',
    't_add_note_description': 'Agregar una nota para explicar esta variación en el consumo de energía con respecto a los objetivos acordados.',
    't_agreed': 'Aceptada',
    't_agreed_actions': 'Acciones acordadas',
    't_asset_agree_actions': 'ES Agreed actions',
    't_all': 'Todo',
    't_all_actions': 'Todas las acciones',
    't_alu': 'Todas las instalaciones',
    't_api_email_error': 'No se encontró el correo electrónico del usuario',
    't_applicable': 'Aplicable',
    't_applicable_actions': 'Acciones aplicables',
    't_approved': 'Aprobado',
    't_apr': 'abr',
    't_april': 'abril',
    't_assets_missing_performance_targets': 'Activos que no alcanzan sus objetivos de rendimiento',
    't_asset_summary': 'Resumen de activos',
    't_assets': 'Activo',
    't_asset_s': 'Activos',
    't_aug': 'ago',
    't_august': 'agosto',
    't_back_sign_in': 'Volver a Iniciar sesión',
    't_biodiversity': 'Biodiversidad',
    't_break': 'interrumpir',
    't_email_hint': 'ES Recipients (separate multiple email addresses with commas)',
    't_btn_enter': 'Introducir los datos',
    't_btn_request': 'Solicitar datos',
    't_building_manager': 'Administrador del edificio',
    't_building_performance': 'Rendimiento del edificio',
    't_cancel': 'Cancelar',
    't_capital_non_recover': 'Capital - No recuperable',
    't_capital_recover': 'Capital - Recuperable',
    't_carbon': 'Carbón',
    't_cbx_label_all': 'Seleccionar todo',
    't_certifications': 'Certificaciones',
    't_certificates': 'ES Certificates',
    't_change': 'Cambio',
    't_change_password': 'Cambiar contraseña',
    't_check_all_completed': 'Marcar todo como completado',
    'close.without.save': '¿Cerrar sin guardar?',
    't_commercial_event': 'Evento Comercial',
    't_commercial_events': 'Eventos Comerciales',
    't_commonareas': 'Zonas comunes',
    't_community_engagement': 'Compromiso de la comunidad',
    't_complete_by': 'Completar para el ',
    't_complete': 'Completado',
    't_completed': 'Completada',
    't_completed_actions': 'Acciones completadas',
    't_completion': 'Completitud',
    't_completion_date': 'Fecha de finalización',
    't_confirm_new_password': 'Confirmar la nueva contraseña',
    't_contact_evora': 'Contacte con EVORA',
    't_contact_problem_msg_1': 'Problema al acceder?',
    't_contact_problem_msg_2': '¿Tiene problemas?',
    't_contact_us': 'Contacte con nosotros',
    't_content': 'Contenido',
    't_cookies': 'Cookies',
    't_cookies_page': '<h1>Use of Cookies</h1><p>This site uses cookies – small text files that are placed on your machine to help the site provide a better user experience.</p><p>In general, cookies are used to retain user preferences, store information for things like shopping baskets, and provide anonymised tracking data to third party applications like Google Analytics. As a rule, cookies will make your browsing experience better. However, you may prefer to disable cookies on this site and on others. The most effective way to do this is to disable cookies in your browser. We suggest consulting the \'Help\' section of your browser or taking a look at the <aboutcookies>About Cookies</aboutcookies> website, which offers guidance for all modern browsers.</p><p>We use cookies to ensure that we give you the best experience on our website. There are 3 types of cookie that we use on this website:</p><h3>1. Strictly Necessary Cookies</h3><p>These cookies are used to enable core site functionality and make the site easier for you to use. They do not contain any personal information and are automatically deleted when you close your browser.</p><h3>2. Google Analytics Cookies</h3><p>These cookies provide us with statistics on how our website is used, so that we can measure and improve the performance of the site, using a service provided by Google.</p><p>Most browsers allow you to turn off the cookie function. If you want to know how to do this please look at the help menu on your browser.</p><h3>Access rights</h3><p>You have a right to access the personal data that is held about you. To obtain a copy of the personal information EVORA holds about you, or to have it deleted from our records altogether (unless it\'s information that we have the right to retain), please email <emailevora>info@evoraglobal.com</emailevora> or call us on +44 (0)20 3326 7333.</p>',
    't_cost': 'Coste',
    't_cost_type': 'Tipo de coste',
    't_create_password': 'Crear nueva contraseña',
    't_current_password': 'Contraseña actual',
    't_data': 'ES Data',
    't_no_records_found': 'ES No records found',
    't_dashboard': 'Cuadro de mandos',
    't_dashboard_pdf': 'SIERA Panel de control.pdf',
    't_data_quality': 'Calidad de los datos',
    't_data_quality_two_lines': 'Calidad {br} de los datos',
    't_date': 'Fecha',
    't_dec': 'dic',
    't_december': 'diciembre',
    't_detail': 'Detalle',
    't_district_cooling': 'Refrigeración de zona',
    't_districtcooling': 'Refrigeración de zona',
    't_district_heating': 'Calefacción de zona',
    't_districtheating': 'Calefacción de zona',
    't_dq_data_entered': 'Datos introducidos',
    't_dq_data_provided_on': 'Proporcionados el',
    't_dq_data_requested': 'Datos solicitados',
    't_dq_data_requested_on': 'Solicitados el',
    't_done': 'Finalizado',
    't_due_date': 'Fecha de entrega',
    't_edit': 'Edición',
    't_electricity': 'Electricidad',
    't_email': 'Su correo electrónico',
    't_email_reset': 'Compruebe su correo electrónico para obtener más información sobre cómo iniciar sesión.',
    't_email_notifications': 'Notificaciones por correo electrónico',
    't_energy': 'Energía',
    't_energyintensity': 'ES Energy Intensity',
    't_energy_rating': 'Clasificación energética',
    't_EPC_rating': 'ES EPC rating',
    't_Asset_EPC_rating': 'ES EPC ratings',
    't_english': 'Inglés',
    't_enter_data': 'Introducir los datos',
    't_enter_current_password': 'Por favor, introduce tu contraseña actual',
    't_error': 'Lo siento, no puedes iniciar sesión',
    't_error_account_locked': 'La cuenta está bloqueada debido a demasiados intentos fallidos.',
    't_error_account_revoked': 'Un administrador ha revocado su acceso a esta cuenta.',
    't_error_back_to_homepage': 'Regresar a la página de inicio',
    't_error_try_msg': 'Vuelva a intentarlo dentro de unas horas.',
    't_error_user_password': 'Correo electrónico o contraseña incorrectos, inténtelo de nuevo.',
    't_error_user_no_access': 'Correo electrónico o contraseña incorrectos, inténtelo de nuevo.',
    't_esg_action_plan': 'Plan de acción',
    't_esg_dashboard': 'Panel de control',
    't_esg_data_quality': 'Calidad de datos',
    't_esg_passport': 'Pasaporte',
    't_esg_performance': 'Rendimiento',
    't_portfolio_pdf': 'ES SIERA Portfolio.pdf',
    't_date_range': 'ES Date range',
    't_add_cost_estimate': 'ES Add cost estimate',
    't_add_manager': 'ES Add manager',
    't_est': 'ESTIM.',
    't_estimated_overspend': 'Exceso de gasto estimado',
    't_event': 'Evento',
    't_events': 'Eventos',
    't_excel': 'Excel',
    't_expand_full_list': 'Expandir la lista completa',
    't_expiry': 'expiración',
    't_export': 'Exportar',
    't_exterior': 'Exterior',
    't_feb': 'feb',
    't_february': 'febrero',
    't_find_asset': 'Buscar activo',
    't_floor_area': 'Superficie del suelo',
    't_forgot_password': 'Ha olvidado la contraseña',
    't_french': 'Francés',
    't_friday': 'Viernes',
    't_fund': 'Fondos',
    't_fund_reports': 'ES Reports',
    't_fund_report_content': 'ES Report Content',
    't_gas': 'ES Gas',
    't_gasFuelsAndThermals': 'Gas, Combustibles Y Termales',
    't_gas_fuel_thermal': 'Gas, combustibles y termales',
    't_gasfuelsandthermals': 'Gas, combustibles y termales',
    't_german': 'Alemán',
    't_go_back': 'Regresar',
    't_governance_recommendations': 'Recomendaciones de gobernanza',
    't_graph_landlord': 'Propietario',
    't_tenant': 'Inquilino',
    't_graph_ytd': 'Anual, hasta la fecha',
    't_gresb_measure': 'Acciones relacionadas con GRESB',
    't_health_and_wellbeing': 'Salud y bienestar',
    't_heatmap_header': 'Metros individuales',
    't_heatmap_no_meterdata_msg': 'No se han encontrado datos de contadores para el servicio y la zona seleccionados.',
    't_impact': 'Impacto',
    't_in_progress': 'En curso',
    't_incorrect_current_password': 'La contraseña actual es incorrecta.',
    't_invalid_token': 'Token no valido.',
    't_italian': 'Italiano',
    't_jan': 'ene',
    't_january': 'enero',
    't_jpg': 'Gráficos JPG',
    't_jul': 'jul',
    't_july': 'julio',
    't_jun': 'jun',
    't_june': 'junio',
    't_kg': 'kg',
    't_kWh': 'KWh',
    't_land_fill': 'Vertedero',
    't_landfill': 'Vertedero',
    't_landfill_remaining': 'Vertedero restante',
    't_landlord': 'Propietario',
    't_landlord_complete': 'Propietario completo',
    't_landlord_missing': 'Falta el propietario',
    't_language': 'Idioma',
    't_last_quarter': 'Último trimestre',
    't_last_refurb': 'Última reforma',
    't_last_refurbished': 'Última renovación',
    't_latest': 'Último',
    't_location': 'Ubicación',
    't_logout': 'Cerrar sesión',
    't_m': 'M',
    't_manager': 'Gestor',
    't_mar': 'mar',
    't_march': 'marzo',
    't_may': 'mayo',
    't_missing': 'INCOMPLETO',
    't_missing_tc': 'Falta',
    't_missing_lc': 'falta',
    't_missing_performance_data': 'Faltan datos de rendimiento',
    't_missing_data': 'Faltan datos',
    't_missing_data_meter': 'Metro',
    't_missing_data_reading': 'Lectura',
    't_missing_data_type': 'Tipo',
    't_monday': 'Lunes',
    't_msg_empty_msg': 'No faltan datos para este período',
    't_msg_no_data': 'No hay datos.',
    't_msg_qtr_empty': 'No se han registrado intervalos de datos para el período seleccionado',
    't_nc': 'NC',
    't_not_covered_uc': 'ES NOT COVERED',
    't_new_password': 'Nueva contraseña',
    't_no': 'No',
    't_no_action_plan': 'No se encontraron datos.',
    't_no_completed_action': 'No se encontraron datos de las acciones completadas.',
    't_no_data_msg_1': 'Lo sentimos, no hemos podido encontrar ningún resultado con {0} - Prueba con otro término de búsqueda.',
    't_no_data_msg_2': 'Lo sentimos, no pudimos encontrar ningún resultado.',
    't_no_events_found': 'Lo sentimos, no pudimos encontrar ningún evento.',
    't_non_recycled': 'No reciclado',
    't_none': 'Ninguno',
    't_non_rec': 'NO-REC',
    't_non_applicable': 'No aplica',
    't_notes': 'Notas',
    't_notif_template_action': '{0} la acción está a 1 mes de la fecha límite. {1}',
    't_notif_template_action_link_1': 'Añade una actualización',
    't_notif_template_data_quality': '{0} datos que faltan para el contador: {1}. {2} or {3} de un colega.',
    't_notif_template_data_quality_link_1': 'Solicitar datos',
    't_notif_template_performance': '{0} rendimiento para {1} es {2}% {3} objetivo. {4} para explicar la variación.',
    't_notif_template_performance_link_1': 'Agregar una nota',
    't_notifications': 'Notificaciones',
    't_nov': 'nov',
    't_november': 'noviembre',
    't_occupancy': 'Ocupación',
    't_oct': 'oct',
    't_october': 'octubre',
    't_oil': 'Gasóleo',
    't_one_year': '1 año',
    't_other': 'Otros',
    't_other_notifications': 'También te notificaremos cuando: ',
    't_outdoorexteriorareaparking': 'Aparcamiento en el exterior',
    't_over': 'superior',
    't_est_overspend': 'gasto excesivo estim.',
    't_passport': 'Libro de registro',
    't_passport_pdf': 'SIERA Pasaporte.pdf',
    't_password': 'Su contraseña',
    't_password_criteria': 'La contraseña no cumple los requisitos',
    't_password_mismatch': 'Las contraseñas no coinciden, por favor comprueba',
    't_password_rules': 'Debe tener 10 caracteres o más e incluir una letra mayúscula, una letra minúscula, un número y un carácter que no sea una letra.',
    't_past_12_months': 'Cada 12 meses',
    't_pdf': 'PDF de página completa',
    't_pdf_exported': 'PDF exportado',
    't_pdf_page': 'Página',
    't_pdf_pagination_copyright': '© El diseño y la maquetación de este informe son propiedad de EVORA Global Limited. Los datos contenidos en este informe se basan únicamente en datos proporcionados por el cliente y pertenecen al cliente. EVORA Global Limited no es responsable de la calidad o exactitud de estos datos.',
    't_perf_pdf': 'SIERA Rendimiento ESG.pdf',
    't_performance': 'Rendimiento',
    't_performance_commerial_event_template': '{0} arrendamiento de inquilinos {1}',
    't_performance_completed_action_template': '{0} - completado',
    't_performance_data_missing_event_template': '{0} datos que faltan para el contador {1} ',
    't_performance_event_template': '{0} el consumo de {1} es {2}% {3} objetivo',
    't_performance_event_waste_template': '{0} el rendimiento de {1} es {2}% {3} objetivo',
    't_performance_variance': 'Rendimiento',
    't_data_quality_issue': 'Calidad de los datos',
    't_pop_up_data_missing': 'Faltan datos',
    't_portfolio_name': 'Cartera',
    't_posted': 'Publicado',
    't_privacy': 'Privacidad',
    't_privacy_page': '<h1>Privacy Policy</h1><p><b>EVORA is committed to protecting your privacy.</b></p><p>At EVORA Global we respect your privacy and commit to protecting your personal data. This “privacy notice” explains what we do with your personal data, why we want to use it, how we protect it, and what rights you have to control our use of it.</p><p>It applies not just to use of our website and data platforms, but also personal data that we process through other interactions with individuals in the course of running our organisation and delivering services, such as individuals working for our customers, partners and suppliers. Our websites and services are not intended for children and we do not knowingly collect data relating to children.</p><p>If you have any questions, concerns or just want some more information about our privacy management, drop us a line at <emailevora>dataprivacy@evoraglobal.com</emailevora>.</p><h3>Some information about us as a data controller</h3><p>This privacy notice is for the EVORA Global Ltd (collectively referred to as “EVORA Global”, “we”, “us” or “our” in this privacy notice). We collect, use and are responsible for certain personal data about you. When we do so we are regulated under data protection laws and we are responsible as “data controller” of that personal information for the purposes of the law.</p><p>Our contact address is: 3rd Floor, Birrane House, 2-4 Southwark Street, London, SE1 1TQ. Our company number is 07450294.</p><h3>What personal data do we process and why?</h3><p>Personal data, or personal information, means any information about an individual from which that person can be identified. It does not include data where the identity has been removed (anonymous data).</p><p>We use personal data from different categories of individual for different purposes and these each have a different \'lawful basis\'. This section describes the lawful basis and purposes in detail and, although it\'s technical, we\'re required by law to explain this to you.</p><p><strong>If you visit our website:</strong>we use Google Analytics on our website to track visitor numbers and user activity on our site. We record your computer\'s IP address, so we can tell how each user and repeat visitor is using our site (your IP address is also a piece of your personal data). We do this on the basis that it is necessary for our legitimate interests in tracking website users so that we can improve our service and keep our websites relevant and useful. The IP address information will be held for 26 months after last user activity.</p><p><strong>If you are a member of our mailing list:</strong>we will use your email address for the purpose of sending you blog posts, our monthly newsletters, and invitations to our events and workshops. We have this data if you signed up on our website or if you provided us with your contact details by email or when meeting our staff. We process this data on the basis that it is necessary for our legitimate interests in promoting and marketing our business. If you no longer wish to hear from us just click the “unsubscribe” links at the bottom of each email.</p><p><strong>If you are a SIERA account holder:</strong> we will hold your name, username and email address on the basis that it is necessary for our legitimate interests in operating a building sustainability data platform for clients. You or your employer will have provided these details through the account creation process. We need these details for the purpose of enabling secure access to the data platform by staff and workers in the supply chain of our clients. We may use this information for internal analysis purposes to understand client platform engagement. We may also report information around your usage of the SIERA tool back to our client, where you work for such client or in such client\'s supply chain (see below). It is in our legitimate interests to provide feedback to our clients for purposes of running and growing our business, and assists us in responding to the needs of our clients. It is also of benefit to our clients to be aware of this usage information. If you no longer require your account, you can email us (see “How to contact us” below). We will hold your information until you or we delete your account.</p><p><strong>If you work for one of our clients or in our clients\' supply chain, or if you are an industry contact or working in a field relevant to our mission:</strong>we may hold your name, company, job title and contact details. We will have been provided with this data either by you or your employer or in some cases we may have sourced it from publicly available sources, such as LinkedIn, internet searches, or third parties. If you have been in contact with us by email or phone we may also have copies of email exchanges or conversation notes. We need this data in order to interact with you (or your employer) for the following purposes:</p><p>1. To run and develop our business; 2. To communicate with interested people regarding events, news and updates.</p><p>We do this on the basis that it is necessary for our legitimate interests in running and growing our business. We will hold your details for as long as we need to interact with you for these purposes. In all cases if you would like us to update or delete your information, please send us an email (see “How to contact us” below).</p><p><strong>If you submit an application to join us, whether as an employee or contractor:</strong>we will hold any personal information you provide to us (via our website or other methods), or that is sent to us by a thirdparty recruitment agency or website. This is likely to be your name, contact details and personal information contained in your CV. We do this on the basis that it is necessary for our legitimate interests in recruiting talented people. We will use this information for the purpose of communicating with you and evaluating your application. We will hold this information for as long as we need to interact with you for these purposes or until you ask us to delete it.</p><p><strong>If you are a supplier or work for a supplier:</strong>we may hold your name and contact details because we have a legitimate interest in doing business with your company. Our purpose for processing your personal data is to interact with you or your employer to procure and pay for goods and services. We will hold this information for as long as we need to interact with you for these purposes. In all cases if you would like us to update or delete your information, please send us an email (see “How to contact us” below).</p><h3>Retention of personal data</h3><p>We will only retain your personal data for as long as necessary to fulfil the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements, taking into account applicable data protection laws, retention periods under applicable laws, limitation periods and our business needs.</p><h3>Sharing your personal data</h3><p><strong>Data processors</strong></p><p>We use a number of different service providers (acting as \'data processors\') who provide IT and system administration services to enable us to operate our business and the services we provide to our users and partners. Your personal data is transferred to (and stored by) these data processors, who generally fall under the following categories:</p><ul><li>Website analytics service providers</li><li>Website and data hosting service providers</li><li>Document storage service providers</li><li>Email, contacts, instant messaging and calendar service providers</li><li>Project management software providers</li><li>CRM service providers</li><li>Accounting software service providers</li></ul><p>For security reasons we do not name all our service providers in this privacy notice. The types of personal data we hold about you (and that may be transferred to our data processors) are set out above. Please contact us if you want further information on specific data processors or the types of personal data they process for us</p><p><strong>If you attend one of our events</strong></p><p>The name and company of attendees at our events may be shared with other participants and may be shared on our website.</p><p>If the event is co-organised with another organisation, then the name and company of attendees may also be shared with that partner organisation to enable access and name badges etc.</p><p><strong>Other circumstances in which we may need to share personal data with third parties</strong></p><p>We may also share your personal data with the following third parties in certain circumstances:</p><ul><li>We will share personal information with law enforcement or other authorities (such as tax authorities) if required by applicable law.</li><li>We may share personal information with third parties as part of a merger or transfer, acquisition or sale, or in the event of a bankruptcy. In such case, we will require the relevant third parties to provide comparable levels of protection as we provide with respect to the information we share.</li><li>We may share personal information with professional advisors such as lawyers, accountants or auditors in order for them to provide us with legal, accounting or auditing services.</li><li>We may share personal information with consultants working for us where this is necessary for them to provide their services to us or our clients.</li><li>We may share personal information with our partner company EVORA EDGE Limited – where this is necessary for them to provide services for the benefit of our clients.</li></ul><p>We will not sell or rent your information to third parties and we will never share your information with third parties for marketing purposes.</p><h3>International transfers of personal data, and the measures in place to safeguard it</h3><p>We do not directly transfer any of your personal data outside the UK or the European Economic Area (EEA). However, some of our data processors may do so and this section explains the impact of these international transfers and how your information is protected.</p><p>Many of our data processors operate “cloud-based systems”, which means the information is held in information data centres in different locations. In some cases, they hold copies of your personal information outside the UK or EEA.</p><p>In each case our processors and/or we employ one or more of the transfer safeguard mechanisms designated by data protection legislation, which are designed to help safeguard your privacy rights and give you remedies in the unlikely event of abuse. These include:</p><ul><li>Certain processors may only transfer your personal data to countries that have been deemed to provide an adequate level of protection for personal data by the UK government or the European Commission. For further details, on EU adequacy decisions see: <europeancommission>European Commission: Adequacy of the protection of personal data in non-EU countries.</europeancommission></li><li>Where we use certain service providers, we may use standard contractual clauses approved by the European Commission or UK ICO, which give personal data the same protection it has in Europe. For further details, see: <europeancommissionstandard>European Commission: Standard Contractual Clauses.</europeancommissionstandard></li></ul><p>Please contact us (see below) if you want further information on the specific mechanisms used by our data processors when transferring your personal data out of the UK or EEA.</p><h3>Your personal data rights</h3><p>The personal data we hold about you is your data, and you have certain rights over the data under applicable data protection laws. This section summarises the rights you have where your personal data is protected under UK data protection legislation.</p><ul><li>You have the right to request a copy of all personal data we hold relating to you. You also have the right to require us to correct any mistakes in the personal data we hold relating to you.</li><li>Where we are processing your data based on your consent you can withdraw that consent and we must immediately stop processing your data.</li><li>Where we process your data based on a “legitimate interest” (underlined in the section on “purpose and lawful basis”, above) you still have the right to object to our processing of that data if you feel it impacts on your fundamental rights and freedoms.</li><li>You also have the right to object where we are processing your personal data for direct marketing purposes. The easiest way to do this is to use the unsubscribe links at the bottom of all marketing emails</li><li>In certain situations, you have the right to require us to erase personal data where there is no good reason for us continuing to process it, or to request restriction of processing of your personaldata.</li><li>Finally, you have the right to request the transfer of your personal data to you or a third party in a structured, commonly used, machine-readable format in certain circumstances.</li></ul><p>For further information on each of these rights, including the circumstances in which they apply, see the <guidanceuk>Guidance from the UK Information Commissioner\'s Office (ICO) on individuals rights under the General Data Protection Regulation.</guidanceuk></p><p>If you would like to exercise any of these rights, the easiest way is by dropping us an email (see “How to contact us” below).</p><h3>Automated processing of your personal data</h3><p>You have a right to object to any decisions being taken through the processing of your personal data by automated means if they produce legal effects concerning you or similarly significant effects on you. We can confirm that we do not undertake any automated decision-making, or profiling, based on the processing of personal data.</p><h3>Keeping your personal information secure</h3><p>We have appropriate security measures in place to prevent personal information from being accidentally lost, or used or accessed in an unauthorised way. In addition, we limit access to your personal data to those employees, contractors and other third parties who have a business need to know. They will only process your personal data on our instructions and they are subject to a duty of confidentiality.</p><p>We also have procedures in place to deal with any suspected data security breach. We will notify you and any applicable regulator of a suspected data security breach where we are legally required to do so.</p><h3>Your rights to lodge a complaint with the Regulator</h3><p>At all times, you have the right to report a concern or lodge a complaint with the Information Commissioner\'s Office. Please refer to the ICO at<icoorg> https://ico.org.uk/concerns/</icoorg> or by calling them on 0303 123 1113. Of course, we hope that we can resolve your issue quickly and fairly ourselves.</p><h3>Changes to this privacy notice</h3><p>This privacy notice was last updated on 16th February 2021. We may change this privacy notice from time to time by amending this page.</p><h3>How to contact us</h3><p>If you have any questions, concerns or just want some more information about our privacy management, drop us a line at <emailevora>dataprivacy@evoraglobal.com</emailevora></p>',
    't_quarterly_email_notification': 'Recibe correos electrónicos trimestrales en los que se destaca: ',
    't_recycled': 'Reciclado',
    't_reduction': 'Reducción',
    't_req_from': 'Desde',
    't_req_hi': 'Hola',
    't_red': 'Faltan datos',
    't_req_meter': 'Metro',
    't_req_missing_data_period': 'Falta(n) período(s) de datos',
    't_req_recipient': 'Destinatarios',
    't_req_send': 'Enviar',
    't_req_subject': 'Asunto',
    't_req_thanks': 'Gracias',
    't_req_utility': 'Instalación',
    't_request_data': 'Solicitar datos',
    't_req_supplier': 'ES Supplier (if known)',
    't_revenue_service': 'Ingresos - Cargo por servicio',
    't_saturday': 'Sábado',
    't_save': 'Guardar',
    't_saving': 'ahorros estimados',
    't_scope': 'Alcance',
    't_select': 'Seleccionar',
    't_send_reminder': 'Enviar un recordatorio',
    't_sep': 'sep',
    't_september': 'septiembre',
    't_set_dates': 'Establecer fechas',
    't_set_reminder_date': 'Establecer fecha de recordatorio de pago',
    't_settings': 'Ajustes',
    't_sharedservices': 'Servicios compartidos',
    't_show_more': 'Mostrar más',
    't_sign_in': 'Iniciar sesión',
    't_six_months': '6 meses',
    't_social_value': 'Valor social',
    't_sort_by': 'Ordenar por',
    't_spanish': 'Español',
    't_status': 'Estado',
    't_submit': 'Enviar',
    't_sunday': 'Domingo',
    't_swedish': 'Sueco',
    't_target': 'Objetivos',
    't_task': 'Tarea',
    't_template_qtr_label': '{0} {1} - {2} {3}',
    't_tenant_complete': 'Inquilino al día',
    't_tenant_missing': 'Inquilino ausente',
    't_tenant_engagement': 'Compromiso del inquilino',
    't_tenant_services': 'Servicios del inquilino',
    't_tenantspace': 'Espacio para inquilinos',
    't_terms': 'Términos',
    't_this_quarter': 'Este trimestre',
    't_three_months': '3 meses',
    't_thursday': 'Jueves',
    't_title_cannot_request_data': 'No se pueden solicitar datos',
    't_title_cannot_post_data': 'ES Add user failed',
    't_title_cannot_put_data': 'ES Update user failed',
    't_title_cannot_put_data_group': 'ES Update group failed',
    't_title_cannot_post_data_group': 'ES Add group failed',
    't_title_cannot_add_asset': 'ES Add asset failed',
    't_today': 'Hoy',
    't_ton': 't',
    't_tonnes': 'toneladas',
    't_total': 'Total',
    't_total_recycling': 'Total de reciclaje',
    't_try_again': 'Intentar otra vez',
    't_tuesday': 'Martes',
    't_type': 'Tipo',
    't_under': 'inferior',
    't_under_review': 'En revisión',
    't_under_target': 'por debajo del objetivo durante el período',
    't_util_cooling': 'Refrigeración de zona',
    't_util_heating': 'Calefacción de zona',
    't_view_all': 'Ver todo',
    't_waste': 'Desperdicio\n' +
      'Reciclaje',
    't_waste_title': 'Desperdicio {0} Reciclaje',
    't_waste_recycling': 'Desperdicio Reciclaje',
    'Waste': 'Residuos',
    't_water': 'Agua',
    't_wednesday': 'Miércoles',
    't_wellbeing': 'Bienestar',
    't_wholebuilding': 'Todo el edificio',
    't_yes': 'Sí',
    't_yesterday': 'Ayer',
    't_y_o_y': 'Interanual',
    't_y_o_y_dialog_text': '<p> <strong> La variación objetivo </strong> se refiere al rendimiento de un activo este año hasta la fecha, en comparación con el mismo período del año pasado para una utilidad determinada, que se muestra como un cambio porcentual año tras año. Si se ha establecido un objetivo en un activo en SIERA para servicios públicos, entonces este porcentaje se basa en el año anterior. </p>',
    't_y_o_y_target': 'Anual, hasta la fecha (variación respecto al objetivo)',
    't_ytd': 'Anual, hasta la fecha (variación respecto al objetivo)',
    't_ytd_uppercase': 'AHF',
    't_show_targets': 'mostrar objetivos',
    't_estimated': 'estimado',
    't_estimate': 'ES ESTIMATED',
    't_start_date': 'fecha de inicio',
    't_end_date': 'fecha final',
    't_year': 'año',
    't_reporting_year': 'ES Reporting Year',
    't_asset_values': 'ES Asset Values',
    't_fossil_fuel_exposure': 'ES Fossil Fuel Exposure',
    't_planning_permission_date': 'ES Planning Permission Date',
    't_epc_coverage': 'ES EPC Coverage',
    't_ped': 'ES PED',
    't_nzeb_threshold': 'ES NZEB Threshold',
    't_asset_floor_area': 'ES Asset Floor Area',
    't_total_raw_materials_weight': 'ES Total Raw Materials Weight',
    't_sustainable_raw_materials_weight': 'ES Sustainable Raw Materials Weight',
    't_total_horizontal_area': 'ES Total Horizontal Area',
    't_total_vertical_area': 'ES Total Vertical Area',
    't_artificial_horizontal_area': 'ES Artificial Horizontal Area',
    't_artificial_vertical_area': 'ES Artificial Vertical Area',
    't_asset_values_extended': ' ',
    't_fossil_fuel_exposure_extended': 'ES An asset is exposed to fossil fuels if it is involved in the extraction, storage, transport or manufacture of fossil fuels. This should be updated quarterly.',
    't_planning_permission_date_extended': 'ES  ',
    't_epc_coverage_extended': 'ES  ',
    't_nzeb_threshold_extended': 'ES A Nearly Zero-Energy Building is one which meets or exceeds an energy performance target calculated according to the appropriate national methodology, for EU nations. Non-EU nations will not have an applicable NZEB threshold.',
    't_asset_floor_area_extended': 'ES The gross internal area of the asset.',
    't_waste_management_extended': 'ES An asset has implemented waste management processes if it is equipped with facilities for waste sorting, and covered by a waste recovery or recycling contract.',
    't_total_raw_materials_weight_extended': 'ES The total weight of raw materials used in new construction or major redevelopment at the asset.',
    't_sustainable_raw_materials_weight_extended': 'ES Sustainable raw materials refers to materials which are recovered, recycled or bio-sourced.',
    't_total_horizontal_area_extended': 'ES This refers to the “plan” or “bird\'s eye” area of the plot, not the internal area.',
    't_total_vertical_area_extended': 'ES This refers to external, vertical surface area.',
    't_artificial_horizontal_area_extended': 'ES “Artificialisation” refers to surfaces that have not been vegetated in ground, as well as on roofs, terraces and walls. This should be less than the reported Total Horizontal Area.',
    't_artificial_vertical_area_extended': 'ES “Artificialisation” refers to surfaces that have not been vegetated in ground, as well as on roofs, terraces and walls. This should be less than the reported Total Vertical Area.',
    't_missing_field_description': 'ES Missing Field Descriptions',
    't_picker_filter_value': '{0} meses hasta el final del {1} {2}',
    't_picker_filter_value_single_month': '{0} mes hasta finales del {1} {2}',
    't_variance_from_target': 'Variación con respecto al objetivo / año anterior',
    't_rank': 'rango',
    't_under_recycling_target': 'Under recycling target for period',
    't_over_recycling_target': 'Over recycling target for period',
    't_est_savings': 'ES est. savings',
    't_add_note_dots': 'Agregar una nota...',
    't_password_reset_success': 'La contraseña se ha reestablecido',
    't_reset': 'Reiniciar',
    't_auto_meter_readings': 'Lecturas automáticas de medidores',
    't_auto_system_upgrades': 'Actualizaciones/reemplazos del sistema de automatización',
    't_composting_landscape': 'Compostaje de residuos de jardinería y/o alimentos',
    't_cooling_tower': 'Torre de refrigeración',
    't_drip_irrigation': 'Riego por goteo/inteligente',
    't_drought_tolerant_landscaping': 'Paisajismo nativo / resistente a la sequía',
    't_high_efficiency_fixtures': 'Accesorios para entornos secos / de alta eficiencia',
    't_installation_equipment': 'Instalación de equipos y electrodomésticos de alta eficiencia',
    't_instructions': 'ES Instructions',
    't_consumption_loader': 'ES Consumption loader',
    't_bulk_add_template': 'ES Bulk Add Template',
    't_bulk_edit_template': 'ES Bulk Edit Template',
    't_installation_renewable': 'Instalación de energía renovable in situ',
    't_leak_detection_system': 'Sistema de detección de fugas',
    't_management_sys_upgrade': 'Actualizaciones/reemplazos de sistemas de gestión',
    't_selected_asset_stranding': 'ES Selected asset CRREM Misalignment in ',
    't_asset_level_model_message': 'ES This will create a model from all applicable and agreed actions related to this asset. If the asset does not have enough consumption data, it will have a sector and country benchmark applied.',
    't_meter_water_subsys': 'Medición de subsistemas hídricos',
    't_not_available': 'No disponible',
    't_occupier_eng_tech': 'Intervención de los ocupantes / tecnologías de la información',
    't_ongoing_waste_monitoring': 'Monitoreo continuo de la eficiencia de la gestión de residuos',
    't_onsite_waste_water_treatment': 'Tratamiento de aguas residuales in situ',
    't_recycling': 'Reciclaje',
    't_reuse_storm_water': 'Reutilización de aguas pluviales o aguas grises',
    't_smart_grid_tech': 'Redes inteligentes / tecnologías de edificios inteligentes',
    't_sys_commissioning': 'Puesta en servicio u optimización de las operaciones de los sistemas',
    't_utility_type': 'Tipo de servicio público',
    't_wall_roof_inst': 'Aislamiento de paredes / techos',
    't_waste_management': 'Gestión de residuos',
    't_waste_stream_audit': 'Auditoría de flujos de residuos',
    't_window_replacement': 'Reemplazo de ventanas',
    't_heatmap_tooltip_content_txt': 'Falta(n) {0} dato(s) para {1} {2}',
    't_heatmap_tooltip_content_txt_partial': 'Falta(n) {0} dato(s) para',
    't_heatmap_tooltip_content_txt_none': '{0} Todos los datos recopilados para {1} {2}',
    't_missing_partial_data': 'Faltan datos parciales',
    't_delete': 'Eliminar',
    't_delete_action_title': 'Eliminar acción',
    't_delete_confirmation': '¿Está seguro?',
    't_go': 'Ir',
    't_error_ok': 'Aceptar',
    't_error_request_400': 'Ocurrió un error al procesar su solicitud.',
    't_error_request_401': 'No tiene el nivel de permiso suficiente para acceder a ese recurso.',
    't_page_not_found': 'ES Page not found',
    't_page_not_found_reason': 'ES You\'ve asked for a page which doesn\'t exist in this application, or you don\'t have access to it. {contactEvora} for help.',
    't_page_auth_error': 'ES There was a problem logging in.',
    't_page_auth_error_reason': 'ES There was a problem authenticating your credentials. Please check them carefully and try again.',
    't_back_to_login': 'ES Try logging in again',
    't_error_user_account_locked': 'La cuenta estará bloqueada durante los siguientes {lockDuration} segundos.',
    't_error_user_internal_login_issue': 'SIERA está experimentando problemas con el servicio. Inténtelo más tarde.',
    't_password_expiry_info': 'La contraseña ha caducado. Cree una nueva contraseña.',
    't_password_must_be_different': 'La nueva contraseña no puede ser la misma que la contraseña que caducó.',
    't_target_beaten': '¡Objetivo alcanzado!',
    't_lower_than_previous': '¡Menor en comparación con el año anterior!',
    't_higher_than_previous': 'Mayor en comparación con el año anterior',
    't_current': 'Objetivo',
    't_previous': 'Variación',
    't_variance': 'anterior',
    't_percentage_missing': 'Falta el % de datos',
    't_target_missed': 'Objetivo no alcanzado',
    't_savings': 'Ahorro',
    't_overspend': 'Gasto adicional',
    't_annual_current_consumption': 'Consumo anual actual',
    't_annual_expected_consumption': 'Consumo anual previsto',
    't_agreed_action': 'Medida acordada',
    't_applicable_action': 'Acción aplicable',
    't_action_under_review': 'Acción en revisión',
    't_notes_lowercase': 'notas',
    't_add_variance_note': 'Agregar una nota para explicar la variación.',
    't_delete_warning': '¿Está seguro de que desea eliminar esta acción?',
    't_details': 'Detalles',
    't_clear': 'Borrar',
    't_edit_user': 'ES Edit user',
    't_groups': 'ES Groups',
    't_my_groups': 'ES My Groups',
    't_add_photo': 'ES Add photo',
    't_name': 'ES Name',
    't_company': 'ES Company',
    't_role': 'ES Role',
    't_email_address': 'ES Email address',
    't_required_fields': 'ES Required fields ',
    't_save_exit': 'ES Save and exit',
    't_post': 'Publicar',
    't_edited': 'editado',
    't_close': 'Cerrar',
    't_calendar': 'Calendario',
    't_chart': 'Gráfico',
    't_exclamation': 'Exclamación',
    't_hand_rightt': 'Señalar con el dedo índice',
    't_info': 'Información',
    't_no_notes': 'No hay notas para mostrar',
    't_no_redirect_data': 'No hay datos redirigidos del servidor',
    't_old_password': 'Contraseña anterior',
    't_confirm_password': 'Confirmar contraseña',
    't_property': 'Instalaciones',
    't_refresh': 'Actualizar',
    't_show_hide_pass': 'Mostrar/ocultar contraseña',
    't_tick': 'Marcar',
    't_help': '¿Necesita ayuda',
    't_help_assistance': 'Si necesita ayuda, haga clic aquí.',
    't_blue': 'Todos los datos recopilados',
    't_not_covered': 'Sin cobertura',
    't_consumption': 'Consumo',
    't_add_action_plan_in_bulk': 'ES Add action plans in bulk',
    't_edit_action_plan_in_bulk': 'ES Edit action plans in bulk',
    't_error_user_username': 'El correo electrónico está sin completar o es inválido.',
    't_landlord_procured': 'Contratado por el propietario',
    't_title_meter_view': 'Vista del medidor',
    't_provider': 'Proveedor',
    't_title_summary': 'Resumen',
    't_tenant_procured': 'Contratado por el inquilino',
    't_yellow': 'Datos estimados',
    't_source': 'Fuente',
    't_reading': 'Lectura',
    't_meters': 'Medidores',
    't_action_happen': 'Cuando se ejecute la acción',
    't_action_completed': 'Cuando se complete la acción',
    't_date_format_check': 'Formato de fecha no reconocido; verifíquelo.',
    't_show_me': 'Mostrarme',
    't_months': 'meses',
    't_month': 'mes',
    't_end_of': 'hasta el final de',
    't_completed_action': 'Acción completada',
    't_review_date': 'Fecha de revisión',
    't_note_post_warning': 'Haga clic en \'Publicar\' para agregar la nota antes de cerrar.',
    't_warning': 'ES Warning',
    't_warning_asset_review': 'This asset is currently being reviewed by an Evora consultant. Contact support@evoraglobal.com for more information.',
    't_string': '-',
    't_dq_landlord_pdf': 'ES SIERA Data Quality Landlord.pdf',
    't_dq_tenant_pdf': 'ES SIERA Data Quality Tenant.pdf',
    't_dq_meter_pdf': 'ES SIERA Data Quality Meter.pdf',
    't_performance_excel': 'ES SIERA Performance.xlsx',
    't_data_quality_zip': 'ES SIERA Data Quality.zip',
    't_data_quality_excel': 'ES SIERA Data Quality .xlsx',
    't_area': 'ES Area',
    't_events_pfg_msg': 'ES Peformance may have been affected by these events',
    't_last_edit': 'ES Last edit',
    't_reports_create': 'ES Create Report',
    't_reports_ready': 'ES Ready',
    't_estimated_data_legend': 'ES Estimated data',
    't_incomplete_data_legend': 'ES Incomplete data',
    't_not_covered_data_legend': 'ES Not covered',
    't_add_details': 'ES Add details',
    't_completed_data_requirements':'ES Completed Data Requirements',
    't_reports_no_assets': 'ES No assets owned in the reporting year',
    't_reports_SFDR': 'ES {count} SFDR fields',
    't_reports_missing_required': 'ES Missing Required Fields',
    't_reports_missing_optional': 'ES Missing Optional Fields',
    't_reports_data_completeness': 'ES Data Completeness',
    't_reports_report_created_on': 'ES Report created on',
    't_reports_data_completeness_missing': 'ES Consumption Data Missing',
    't_reports_report_completeness': 'ES Report Completeness',
    't_reports_report_completeness_missing': 'ES {count} Assets are missing required data.',
    't_reports_percentage_complete': 'ES {percentage}% complete',
    't_reports_percentage_complete_consumption_data': 'ES {percentage}% complete consumption data',
    't_reports_create_report_header': '{year} ES Report',
    't_reports_save': 'ES Save Report',
    't_reports_assetplanningpermissiondate_not_found': 'ES Planning Permission Date',
    't_reports_assetnzeb_not_found': 'ES NZEB Threshold',
    't_reports_assetped_not_found': 'ES Primary Energy Demand',
    't_reports_giaM2_not_found': 'ES GIA (M2)',
    't_reports_gresbmgtstatus_not_found': 'ES GRESB Management Status',
    't_reports_artificialhorizontalarea_not_found': 'ES Artificial Horizontal Area',
    't_reports_artificialverticalarea_not_found': 'ES Artificial Vertical Area',
    't_reports_totalhorizontalarea_not_found': 'ES Total Horizontal Area',
    't_reports_totalverticalarea_not_found': 'ES Total Vertical Area',
    't_reports_gav_not_found': 'ES GAV',
    't_reports_fossilfuelexposure_not_found': 'ES Fossil Fuel Exposure',
    't_reports_wasteproduction_not_found': 'ES Waste Data',
    't_reports_constructionmaterialweight_not_found': 'ES Resource Consumption Data',
    't_reports_assetepc_not_found': 'ES EPC not found',
    't_reports_assetepc_not_valid': 'ES EPC not valid',
    't_reports_assetepc_insufficient_coverage': 'ES EPC insufficient coverage',
    't_reports_assetepc_not_found_msg': 'ES No EPCs were found for this asset, so it will be categorised as energy-inefficient. If this is incorrect, provide valid EPC(s) for the asset, or indicate that it is exempt from these requirements below.',
    't_reports_assetepc_not_valid_msg': 'ES The EPCs at this asset are not valid for the reporting period, so it will be categorised as energy-inefficient. If this is incorrect, provide valid EPC(s) for the asset.',
    't_reports_assetepc_insufficient_coverage_msg': 'ES The EPCs at this asset do not cover sufficient floor area, so it will be categorised as energy-inefficient. If this is incorrect, provide additional EPC(s), or indicate that units are EPC exempt.',
    't_explanation': 'ES Explanation',
    't_explanation_placeholder': 'ES Type in explanation',
    't_actions_taken': 'ES Actions Taken',
    't_actions_taken_placeholder': 'ES Type in actions taken',
    't_adverse_impact': 'ES Adverse Impact',
    't_fossil_fuels_exposure': 'ES Fossil Fuels Exposure',
    't_energy_efficiency': 'ES Energy Efficiency',
    't_energy_consumption': 'ES Energy Consumption',
    't_resource_consumption': 'ES Resource Consumption',
    't_adverse_impact_fossil_fuels': 'ES Exposure to fossil fuels through real estate assets.',
    't_adverse_impact_energy_efficiency': 'ES Exposure to energy-inefficient real estate assets.',
    't_adverse_impact_ghg_emissions': 'ES Greenhouse Gas Emissions',
    't_adverse_impact_energy_consumption': 'ES Energy Consumption Intensity',
    't_adverse_impact_waste': 'ES Waste production in operations',
    't_adverse_impact_resource_consumption': 'ES Raw materials consumption for new construction and major renovations',
    't_adverse_impact_biodiversity': 'ES Land artificialisation',
    't_impact_value': 'ES Impact Value',
    't_impact_value_fossil_fuels': 'ES Share of investments in real estate assets involved in the extraction, storage, transport or manufacture of fossil fuels.',
    't_impact_value_energy_efficiency': 'ES Share of investments in energy-inefficient real-estate assets',
    't_impact_value_ghg_emissions': 'ES Scope 1, 2, 3 and Total emissions generated by real estate assets',
    't_impact_value_energy_consumption': 'ES Energy consumption in GWh of owned real estate assets per square meter of gross internal area',
    't_impact_value_waste': 'ES Share of real estate assets not equipped with facilities for waste sorting and not covered by a waste recovery or recycling contract',
    't_impact_value_resource_consumption': 'ES Share of raw building materials (excluding recovered, recycled and biosourced) compared to the total weight of building materials used in new construction and major renovations',
    't_impact_value_biodiversity': 'ES Share of non-vegetatedsurface area (surfaces that have not been vegetated in ground, as well as on roofs, terraces and walls) compared to the total surface area of the plots of all assets',
    't_lease': 'ES Lease',
    't_back_t_a_users': 'ES Back to all users',
    't_members': 'ES Members',
    't_groups_none': 'ES No Groups Found',
    't_assets_none': 'ES No Assets Found',
    't_selected': 'ES selected',
    't_access': ' to access',
    't_upload': 'ES Upload',
    't_add_asset': 'ES Add asset',
    't_upload_select_or_drop_file': 'ES Select or drop a file',
    't_upload_here_jpg': 'ES here (JPG)',
    't_upload_image': 'ES Upload image',
    't_upload_footer_info': 'ES Image file must be a jpg/png and no bigger than 2mb in size',
    't_choose_assets_for': 'ES Choose resources for',
    't_admin': 'ES Admin',
    't_administrator': 'ES Administrator',
    't_user1': 'ES User1',
    't_user': 'ES User',
    't_users': 'ES Users',
    't_add_user': 'ES Add user',
    't_recycling_target_beaten': 'ES Recycling target beaten',
    't_more_recycled_than_previous_year': 'ES More recycled than previous year!',
    't_recycling_target_missed': 'ES Recycling target missed',
    't_less_recycled_than_previous_year': 'ES Less recycled than previous year',
    't_next_choose_groups': 'ES Next - Choose Groups',
    't_next_choose_assets': 'ES Next - Choose Assets',
    't_choose_groups_for_new_user': 'ES Choose the users that will have access to this group',
    't_choose_groups_for_update_user': 'ES Choose the groups {0} has access to',
    't_choose_users_for_update_group': 'ES Choose the users {0} has access to',
    't_choose_users_who_will_be_able_to_access_group': 'ES Choose users who will be able to access  ‘{0}’',
    't_find_group': 'ES Find group',
    't_add_new_group': 'ES Add new group',
    't_created': 'ES Created',
    't_choose_assets_for_update_user': 'ES Choose the assets {0} has access to',
    't_choose_assets_for_new_user': 'ES Choose the assets this user will have access to',
    't_last_login': 'ES Last login',
    't_add_new_user': 'ES Add new user',
    't_find_user': 'ES Find user',
    't_home': 'ES Home',
    't_users_not_found': 'ES Sorry we couldn\'t find any Users.',
    't_title_cannot_post_user_asset_groups': 'Add user asset groups failed',
    't_title_cannot_put_user_asset_groups': 'Update user asset groups failed',
    't_contact_problem_access': 'ES Problem getting access',
    't_full_name': 'ES Full name',
    't_create_siera_account': 'ES Create your SIERA account',
    't_password_not_match': 'ES Passwords do not match',
    't_title_cannot_signup': 'ES Signup failed',
    't_title_cannot_post_user_asset_access': 'Add user asset access failed',
    't_title_cannot_put_user_asset_access': 'Update user asset access failed',
    't_retail': 'ES  Retail',
    't_office': 'ES Office',
    't_industrial': 'ES Industrial',
    't_residential': 'ES Residential',
    't_hotel': 'ES Hotel',
    't_lodgingleisurerecreation': 'ES Lodging Leisure Recreation',
    't_education': 'ES Education',
    't_technologyscience': 'ES Technology Science',
    't_healthcare': 'ES Healthcare',
    't_mixeduseoffice': 'ES Mixed Use Office',
    't_asset_details': 'ES Asset details',
    't_select_sector': 'ES Select sector',
    't_select_gresb_sector': 'ES Select GRESB sector',
    't_building_utilities': 'ES Building utilities present',
    't_select_building_utilities': 'ES Select building utilities present',
    't_gav_evaluation_date': 'ES GAV evaluation date',
    't_operation_control': 'ES Operational control',
    't_select_operational_control': 'ES Select operational control',
    't_building_details': 'ES Building details',
    't_postcode': 'ES Postcode',
    't_city': 'ES City',
    't_select_city': 'ES Select a city',
    't_select_country': 'ES Select a country',
    't_select_region': 'ES Select a region',
    't_select_date': 'ES Select date',
    't_select_fund': 'ES Select a fund',
    't_asset_ownership': 'ES Fund ownership',
    't_sold_date': 'ES Sold date',
    't_year_built': 'ES Year built',
    't_select_asset_status': 'ES Select asset\'s current status',
    't_current_status': 'ES Current status',
    't_lifecycles_explanation': 'ES Ensure accurate reporting and data calculations by tracking asset events.',
    't_lifecycles': 'ES Lifecycle',
    't_current_status_tooltip': 'ES What is your asset\'s current stage in its ownership lifecycle?',
    't_asset_ref_tooltip': 'ES A unique name you assign to assets for easy identification within Siera.',
    't_land': 'ES Land',
    't_standing_investment': 'ES Standing Investment',
    't_new_construction': 'ES New Construction',
    't_major_renovation': 'ES Major Renovation',
    't_static_reporting_data': 'ES Static reporting data',
    't_periodic_reporting_details': 'ES Periodic reporting details',
    't_key_dates': 'ES Key dates',
    't_epc': 'ES EPC',
    't_users_groups': 'ES Users & Groups',
    't_asset_name_tc': 'ES Asset Name',
    't_asset_reference_tc': 'ES Asset Reference',
    't_asset_name': 'ES Asset name',
    't_asset_reference': 'ES Asset reference',
    't_find_address': 'ES Find address',
    't_add_address_manually': 'ES Add address manually',
    't_number_identifier': 'ES Number / Identifier',
    't_street': 'ES Street',
    't_town_city': 'ES Town/City',
    't_county': 'ES County',
    't_country': 'ES Country',
    't_region': 'ES Region',
    't_postcode_zip': 'ES Postcode/ZIP',
    't_sector_type': 'ES Sector type',
    't_gross_asset_value': 'ES Gross Asset Value (GAV)',
    't_fri': 'ES Full repairing and insuring lease',
    't_floor_areas': 'ES Floor Areas',
    't_gia': 'ES Gross Internal Area (GIA)',
    't_nla': 'ES Net Lettable Area (NLA)',
    't_cpa': 'ES Common Parts Area (CPA)',
    't_ext': 'ES External Area (EXT)',
    't_units': 'ES Units',
    't_units_desc': 'ES Do you want to be able to add data for units? (You can do this later)',
    't_next_add_key_dates': 'ES Next - Add Key dates',
    't_form_error_message': 'ES Please fill all the required fields',
    't_asset_existing_group': 'ES This asset is part of a selected fund or group',
    't_organisation': 'ES Organisation',
    't_user_warning_message': 'ES Are you sure you want to cancel this action?',
    't_user_invited_to_join_siera': 'ES {0} has been invited to join SIERA',
    't_user_creation_confirmation_popup_title': 'ES Confirmation',
    't_user_revocation_successful': 'ES {0} has been successfully revoked',
    't_resend_invite': 'ES Resend invite',
    't_instance': 'ES Instance',
    't_instance_different': 'ES Please select an instance which is not your current one.',
    't_change_instance': 'ES Change instance',
    't_change_instance_explanation': 'ES When you change of instance you will be automatically logged out and redirected to the correct instance login screen where you can use your usual credentials.',
    't_wrong_instance': 'ES Switch instance?',
    't_wrong_instance_explanation': 'ES You are trying to access an instance which is not your active one. Do you want to switch instances?',
    't_continue_to': 'ES Re-login to',
    't_switch_to': 'ES Yes, switch to',
    't_could_not_find_groups': 'ES Sorry we couldn\'t find any Groups.',
    't_developer': 'ES Developer',
    't_delete_group': 'ES Delete Group',
    't_description': 'ES Description',
    't_groups_not_found': 'ES Sorry we couldn\'t find any Groups.',
    't_view_all_resources': 'ES View all {0} resources',
    't_view_all_assets': 'ES View all {0} assets',
    't_fund_name': 'ES Fund name',
    't_investment_stage': 'ES Investment stage',
    't_search_scheme_asset_name': 'ES Search by scheme and asset name',
    't_green_building_certificates': 'ES Green Building Certificates',
    't_energy_rating_certification': 'ES Energy Rating Certification', 
    't_scheme': 'ES Scheme',
    't_reference_no': 'ES Reference no',
    't_rating': 'ES Rating',
    't_score': 'ES Score',
    't_unit': 'ES Unit',
    't_certified_floor_area': 'ES Certified floor area',
    't_valid_from_date': 'ES Valid from date',
    't_file_upload': 'ES File upload',
    't_uploaded_date': 'ES Upload date',
    't_gav': 'ES GAV',
    't_total_floor_area': 'ES Total floor area',
    't_contains': 'ES Contains',
    't_total_floor_area_gia': 'ES Total floor area (GIA)',
    't_financial_year_starts': 'ES Financial year starts',
    't_carbon_emissions': 'ES Carbon Emissions',
    't_energy_intensity': 'ES Energy intensity',
    't_recycled_waste': 'ES Recycled Waste',
    't_gap_filled_data': 'ES gap-filled data',
    't_below_target': 'ES below target',
    't_above_target': 'ES above target',
    't_key_facts': 'ES Key facts',
    't_funds': 'ES Funds',
    't_my_organisations': 'ES My Organisations',
    't_net_zero_carbon': 'ES Net Zero Carbon',
    't_cco_fund_model': 'ES CCO Fund - Model',
    't_data-source_nzc': 'ES Data source: SIERA',
    't_kg_co2_year': 'ES kgCO₂e/m²/year',
    't_kwh_m2_year': 'ES kWh/m²/year',
    't_bau_ghg_intensity': 'ES Business as usual (BAU)',
    't_scientific_ghg_intensity': 'ES Science based target (1.5C)',
    't_scientific_ghg_intensity(2.0)': 'ES Science based target (2.0C)',
    't_no_organisations_message': 'ES No Organisations Found',
    't_rise': 'ES rise',
    't_fall': 'ES fall',
    't_next_choose_funds': 'ES Next - Choose Funds',
    't_find_fund': 'ES Find fund',
    't_choose_funds_for_user': 'ES Choose the funds this user will have access to',
    't_choose_funds_for_update_user': 'ES Choose the funds {0} has access to',
    't_proportion_missing_data': 'ES Portion of missing fund data',
    't_incomplete': 'ES Incomplete',
    't_total_missing': 'ES Total missing',
    't_revoke_access': 'ES Revoke access',
    't_grant_access': 'ES Grant access',
    't_user_access_revoked': 'ES This user\'s access has been revoked',
    't_user_revoke_confirm_message': 'ES This user will be deactivated and will no longer be able to log in.',
    't_actions_by_assets': 'ES Actions by asset ({0})',
    't_overdue': 'ES Overdue',
    't_items_per_page': 'ES Items per page',
    't_of': 'ES of',
    't_total_costs': 'ES Total costs',
    't_non_recoverable': 'ES Non-recoverable',
    't_un_costed': 'ES Un-costed',
    't_gap_filled_data_above_target': 'ES Gap-filled data (above target)',
    't_actual_data_above_target': 'ES Actual data (above target)',
    't_actual_data_legend': 'ES Actual data',
    't_gap_filled_data_legend': 'ES Gap-filled data',
    't_over_target_legend': 'ES Over target',
    't_show': 'ES Show',
    't_quarterly_data': 'ES Quarterly data',
    't_monthly_data': 'ES Monthly data',
    't_how_we_calculate': 'ES How we calculate this',
    't_fund_graph_carbon_explanation': 'ES Graph showing total carbon emissions for scopes 1, 2 and 3.',
    't_site_admin': 'ES Site admin',
    't_my_account': 'ES My account',
    't_my_profile': 'ES My profile',
    't_aggregated_performance_assets_model': 'Rendimiento agregado de los activos utilizados en el modelo',
    't_agreed_overlay_text': 'ES In the current NZC model, assetCountWithNoAgreedActions out of totalAssets assets have no agreed energy-saving actions.',
    't_action_based_overlay_text': 'ES In the current NZC model, all totalAssets assets have at least one energy-saving action defined.',
    't_asset_error_message': 'ES Selected assets does not have sufficient data',
    't_aggregated_data_quality_assets_model': 'Calidad de los datos agregados para los activos utilizados en el modelo',
    't_based_on_baseline_year': 'Basado en el año de referencia',
    't_based_on_year': 'ES Based on year',
    't_carbon_intensity': 'Intensidad de carbono',
    't_cost_intensity': 'Intensidad de costes',
    't_co2_emissions': 'emisiones de CO₂e',
    't_feedback-panel-label': 'ES How could we improve this page?',
    't_feedback_form_header': 'ES Your feedback',
    't_feedback_form_info': 'ES Would you be happy to speak to us in more depth about your experience of using SIERA?',
    't_feedback_form_label': 'ES Yes, I am happy to be contacted to give more feedback',
    't_target_delta': 'ES target/delta',
    't_sector': 'ES Sector',
    't_no_data_available': 'ES There is no data available',
    't_feedback_success': 'ES Successfully Sent the feedback',
    't_add_feedback_failed': 'ES Add user feedback failed',
    't_about_scopes': 'Acerca de los alcances',
    't_about_scopes_info': 'Estas métricas de emisiones de carbono ilustran el impacto de las actividades requeridas para operar directamente un edificio, es decir, calefacción, iluminación, etc. Incluyen las emisiones de los inquilinos (alcance 3) para los servicios públicos utilizados por los inquilinos del edificio, pero no incluyen las actividades extendidas requeridas para el negocio del inquilino.',
    't_more_details': 'Más detalles',
    't_user_last_loggedIn_at': 'ES Last logged in at {0} on {1}',
    't_total_data_missing': 'ES Total data missing',
    't_landlord_data_missing': 'ES Landlord data missing',
    't_tenant_data_missing': 'ES Tenant data missing',
    't_total_waste': 'Residuos totales',
    't_water_intensity': 'Intensidad del agua',
    't_assets_wo_agreed_action': 'ES Assets without agreed actions',
    't_assets_wo_completed_action': 'ES Assets without completed actions',
    't_coverage_by_floor_area': 'ES Floor area coverage',
    't_valid_certs_by_floor_area': 'ES Valid certificates by floor area',
    't_expire_within_12_months': 'ES Expire within 12 months',
    't_no_certs': 'ES No certificates found',
    't_top_impact_cat': 'ES Top 5 impact categories',
    't_user_not_logged_in': 'ES User has not logged in yet.',
    't_total_data': 'ES Total data',
    't_landlord_proc_data': 'ES Landlord-procured data',
    't_tenant_proc_data': 'ES Tenant-procured data',
    't_landlord_proc_building': 'ES Landlord procures whole building',
    't_tenant_proc_building': 'ES Tenant procures whole building',
    't_otherfuelsandthermals': 'ES Other Fuels & Thermals',
    't_funds_none': 'ES No Funds Found',
    't_funds_performance_cost_higher': 'ES higher than previous period',
    't_funds_performance_cost_lower': 'ES lower than previous period',
    't_gap_filled_data_NA': 'ES gap-filling not available',
    't_only_for_annual_data': 'ES Only available for annual data.',
    't_performance_energy_intensity_coming_soon': 'ES Performance for Energy Intensity coming soon.',
    't_non_recycled_waste': 'ES Non-recycled waste',
    't_total_carb_emissions': 'ES total carbon emissions',
    't_total_elec_used': 'ES total electricity used',
    't_total_gas_fuels_thermals': 'ES total gas fuels & thermals',
    't_total_water_used': 'ES total water used',
    't_total_recycled_waste': 'ES total recycled waste',
    't_fund_rise_than_previous_period': 'aumento sobre el período anterior!',
    't_fund_fall_than_previous_period': 'caer sobre el período anterior!',
    't_estimated_saving': 'ahorro estimado',
    't_recycledwaste': 'Residuos Reciclados',
    't_nzc_available_siera': 'ES Net Zero Carbon available in SIERA',
    't_epc_analysis': 'ES EPC Analysis',
    't_water_units': 'm³',
    't_assets_in_the_model': 'activos en el modelo',
    't_date_of_export': 'ES Date of export',
    't_target_pathway_info': 'ES Target pathways allow you to define a year-on-year plan for % carbon reduction for your model,\n relative to your baseline year.',
    't_action_based_target_pathway': 'ES Action-based pathways aggregate all of the energy-saving actions that have been defined for the assets in the current model and present them as a single pathway for your fund.',
    't_science_based_target_pathway': 'ES This is an area weighted decarbonisation pathway based on your selected assets aligned to the Paris Climate Goals. This shows the carbon intensity required to keep in line with the commitments to limit global warming.',
    't_custom_target_pathway': 'ES Custom target pathways allow you to specify your own targets over time for assets in your model.',
    't_target_pathway_1': 'ES Target Pathway 1',
    't_action_based_carbon_pathway': 'ES Action based pathway',
    't_action_based_pathways': 'ES Action-based pathways',
    't_action_based_energy_intensity_pathway': 'ES Action based energy intensity pathway',
    't_energy_saving_action': 'ES Use energy-saving actions to generate a NZC pathway',
    't_agreed_actions_count': 'ES {0} Agreed actions (required)',
    't_applicable_actions_count': 'ES {0} Applicable actions (recommended)',
    't_science_based_target': 'ES CRREM Science Based Targets (SBT)',
    't_SBT_option_1': 'ES 1.5C SBT',
    't_SBT_option_2': 'ES 2.0C SBT',
    't_custom_target_pathways': 'ES Custom target pathways',
    't_tp_stranding_year': 'ES CRREM Misalignment year in ',
    't_show_progress_towards_target_for': 'ES Show progress towards target for ',
    't_cumulative': 'ES Cumulative',
    't_apply': 'ES Apply',
    't_targets': 'ES Targets',
    't_targets_and_pathways': 'ES Targets & Pathways',
    't_grid_decarbonisation': 'ES grid decarbonisation',
    't_title_cannot_create_target_pathway': 'ES Create target pathway failed',
    't_improvement': 'ES Improvement',
    't_epc_available_siera': 'ES Detailed EPC analysis available in SIERA',
    't_waste_utility': 'Desperdicio',
    't_model': 'Modelo',
    't_models': 'Modelos',
    't_create_new_model': 'Crear un nuevo modelo',
    't_open_model': 'Abrir un modelo',
    't_share_model': 'ES Share model',
    't_link': 'ES Link',
    't_copy_link': 'ES Copy link',
    't_link_copied': 'ES Link copied',
    't_share': 'ES Share',
    't_duplicate_model': 'Modelo duplicado',
    't_export_config_data': 'Exportar datos de configuración',
    't_import_config_data': 'Importar datos de configuración',
    't_search': 'Búsqueda',
    't_open': 'Abierto',
    't_no_models_are_created_yet': 'Todavía no se crean modelos',
    't_default_model': 'Establecer como modelo predeterminado',
    't_delete_model': 'Eliminar modelo',
    't_delete_yes_cancel': '¡borrar esto! /',
    't_bau_stranding': 'ES BAU CRREM Misalignment',
    't_no_model': 'ES No models found',
    't_create_new_model_para': 'Esto creará un modelo a partir de todos los activos actuales y válidos de este fondo. A cualquier activo que no tenga suficientes datos de consumo se le aplicará un benchmark de sector y país.',
    't_create': 'Crear',
    't_name_required': 'Se requiere el nombre.',
    't_model_name_not_valid': 'ES Enter a valid model name',
    't_save_changes': 'Guardar cambios',
    't_filter': 'Filtrar',
    't_all_sectors': 'ES All sectors',
    't_all_countries': 'ES All countries',
    't_assets_filter_result': 'ES {0} out of {1} assets will be displayed',
    't_assets_filter_count': 'ES filters selected:',
    't_assets_filter_title': 'ES Filter',
    't_about_gap_filled_data': 'ES About gap-filled data',
    't_gap_filled_data_dialog_content': '<p>ES Gap-filling missing data is less accurate than using complete\nactual data, but does allow users to\nsee an indicative, realistic picture\nof a fund or asset\'s performance.</p>',
    't_default_model_delete': 'ES Default models cannot be deleted. \nTo delete this Model, set another model as the Default model, then return to this model\'s settings and select delete.',
    't_no_results': 'ES No results found.',
    't_no_graph_data': 'ES No graph data',
    't_getting_scope_data': 'ES Getting Scope Data...',
    't_creating_default_scope': 'ES Creating default scope...',
    't_rise_over_previous_period': 'SE rise over previous period',
    't_sort': 'Clasificar',
    't_lowest_first': 'Más bajo primero',
    't_highest_first': 'La más alta primero',
    't_nzc_data_missing': 'ES Data missing',
    't_nzc_carbon_intensity': 'ES Carbon intensity',
    't_current_action_plan': 'ES Current Action Plan',
    't_current_epc_analysis': 'ES Current EPC Analysis',
    't_sold': 'ES SOLD',
    't_data_warning': 'ES DATA WARNING',
    't_siera_experience_feedback': 'ES I\'d be happy to speak in more depth about my experience of using SIERA',
    't_assets_not_in_model': 'ES assets are not included in this NZC model',
    't_reason_assets_not_in_model': 'ES These may include assets that have been sold, failed NZC validation or manually removed from the model.',
    't_view_these_assets': 'ES View these assets',
    't_export_model_explanation_text': 'ES You can manually change the utility consumption amounts for each asset in the model by downloading the configuration as an Excel file, changing it and uploading the changes back to the model',
    't_export_model_explanation_text_asset': 'ES You can manually change the utility consumption amounts for an asset in the model by downloading the configuration as an Excel file, changing it and uploading the changes back to the model',
    't_export_file_error_message': 'ES The export file name must not contain more than 50 characters',
    't_top': 'ES Top',
    't_import_model_explanation_text': 'ES To import asset data from Excel you must use the {0} template',
    't_import': 'ES Import',
    't_drag_file': 'ES Drag file to upload, or',
    't_select_file': 'ES Select a file',
    't_import_create_explanation': 'ES What do you want the new NZC model to be called?',
    't_upload_success_msg': 'ES has been successfully uploaded',
    't_upload_error_msg': 'ES There are problems with your file',
    't_row': 'ES Row',
    't_copy_clipboard': 'ES Copy to clipboard',
    't_select_valid_file': 'ES Select a valid file',
    't_copied': 'ES Copied',
    't_loading': 'ES Loading',
    't_procurement_tabs_explanation_title': 'ES What do these categories mean?',
    't_data_categories': 'ES Data Categories',
    't_about_procurement_data_categories': 'ES <p><b>Actual:</b> consumption data entered for a meter.</p> <p><b>Estimated:</b> meter data derived from supplier estimates (e.g. from invoices).</p> <p><b>Incomplete:</b> where a meter for a building area has been set up but is missing data for one or more time periods (this is a measure of time).</p> <p><b>Not covered:</b> where we have no information about meters in a given part of a building for a given utility, but we believe this utility is being consumed (this is a measure of floor area). These areas are always assumed to be tenant-procured rather than landlord-procured, except for landlord-controlled assets where no meters have been added.</p> <p><b>Missing:</b> the combination of \'Incomplete\' and \'Not covered\'.</p>',
    't_duplicate_model_para': 'ES This will create a duplicate model with all of the assets from the current model. Any assets which do not have enough consumption data will have a sector and country benchmark applied.',
    't_asset_level_duplicate_model_para': 'ES This will create a duplicate model from all applicable and agreed actions related to this asset. If the asset does not have enough consumption data, it will have a sector and country benchmark applied.',
    't_delete_target_pathway_title': 'ES Delete Target Pathway',
    't_delete_target_pathway_message': 'ES Are you sure you want to delete this pathway?',
    't_add_another_target_pathway': 'ES Add another Target Pathway',
    't_add_a_target_pathway': 'ES Add a Target Pathway',
    't_target_pathway': 'ES Target pathway',
    't_milestone_years': 'ES Milestone years',
    't_group_leaving_confirmation': 'ES Thanks, Admin have been sent your request and we will be back in touch shortly',
    't_group_reason': 'ES What is your reason for leaving the group?',
    't_request': 'ES Request',
    't_leave_group': 'ES Request to leave the group',
    't_add_group': 'ES Create new Group',
    't_target_warning': 'ES The cumulative amount is 100% and cannot be increased. Please revise the reduction percentages.',
    't_chart_options': 'ES Chart options',
    't_plot_data_assets': 'ES Plot data for individual assets',
    't_display_benchmark': 'ES Display benchmark',
    't_data_source': 'ES Data source',
    't_show_progress_relative': 'ES Show progress relative to target for',
    't_base_line_year': 'ES Baseline year',
    't_raw_data': 'ES Raw data',
    't_siera': 'ES SIERA',
    't_imported': 'ES Imported',
    't_uplifted_data': 'ES Uplifted data',
    't_uplifted_estimated_data': 'ES Uplifted/estimated data',
    't_complete_data': 'ES Complete data',
    't_benchmark_data': 'ES Benchmarked data',
    't_previous_period': 'ES Previous period',
    't_this_period': 'ES This period',
    't_gap_filled': 'ES Gap filled',
    't_combined': 'ES Combined',
    't_actual_and_supplier_estimated': 'ES Actual & supplier estimated',
    't_recycled_waste_previous': 'ES Recycled waste (previous)',
    't_choose_assets_group_for_update_user': 'ES Choose assets to include in ‘{0}’',
    't_choose_assets_group_for_new_user': 'ES Choose assets for this group to access',
    't_group_name': 'ES Group name',
    't_email_leave_group': 'ES To request to leave this group, please email',
    't_data_shown': 'ES Data shown',
    't_show_details': 'ES Show details',
    't_hide_details': 'ES Hide details',
    't_view_asset': 'ES View asset',
    't_gia_small_form': 'ES GIA',
    't_asset_ref': 'ES Asset ref',
    't_stranding_year': 'ES CRREM Misalignment year',
    't_energy_saving': 'ES Energy-saving actions',
    't_target_stranding_year': 'ES Target pathway CRREM Misaligned in ',
    't_bau_stranding_year': 'ES BAU CRREM Misalignment in ',
    't_next_users': 'ES Next - Choose Users',
    't_delete_group_msg': 'ES Are you sure you want to delete this group?',
    't_edit_group': 'ES Edit group : ',
    't_all_assets': 'ES All assets',
    't_not_included_in_model': 'ES Not included in current NZC model',
    't_including_gap_filled': 'ES Including gap-filled data',
    't_excluding_gap_filled': 'ES Excluding gap-filled data',
    't_asset_without_energy_saving_action': 'ES Assets with no energy saving actions specified',
    't_sold_assets': 'ES Sold assets',
    't_sold_label': 'ES Asset sold',
    't_asset_status': 'ES Asset status',
    't_no_data_for_previous_period': 'ES no data for previous period',
    't_x_axis_scale': 'ES X-axis scale',
    't_y_axis_scale': 'ES Y-axis scale',
    't_autoscale': 'ES Autoscale',
    't_from': 'ES From',
    't_to': 'ES to',
    't_min': 'ES Min',
    't_max': 'ES Max',
    't_selected_asset': 'ES Selected asset',
    't_no_gresb_sector_error_message': 'ES Asset has no GRESB Sector or Country defined',
    't_asset_data_missing_message': 'ES Asset has critical information missing',
    't_asset_sold_date_message': 'ES Asset sold in',
    't_more_recycled': 'ES more recycled than previous period',
    't_less_recycled': 'ES less recycled than previous period',
    't_required_group_field': 'ES Required field',
    't_form_group_error_message': 'ES Please fill the required field',
    't_upload_nzc_data_failed': 'ES Upload NZC import data failed',
    't_nzc_file_uploaded_success': 'ES {0} file successfully uploaded',
    't_default_model_name': 'ES Default model',
    't_metric': 'ES Metric',
    't_imperial': 'ES Imperial',
    't_energy_intensity_popup_header': 'ES Coming soon',
    't_energy_intensity_popup_body': 'ES Detailed performance view for Energy Intensity coming soon.',
    't_epc_analysis_popup_header': 'ES Coming soon',
    't_epc_analysis_popup_body': '<p> ES Detailed EPC analysis will be available soon and is currently  <a>available in SIERA </a> </p>',
    't_model_notes': 'ES Model notes',
    't_setting_default_model_failed': 'ES Setting model as default failed',
    't_set_as_default': 'ES Set as Default Model',
    't_set_as_default_info': 'ES This is the model that is displayed on the fund dashboard, and will be the first NZC model viewed by SIERA users. We recommend using your ‘best’ model as the default.',
    't_set_as_default_asset_info': 'ES This will be the first NZC model viewed by SIERA users. We recommend using your ‘best’ model as the default.',
    't_nzc_default_text': 'ES NZC default',
    't_unable_to_plot_NZC_chart': 'ES Unable to plot NZC chart.',
    't_unable_to_plot_NZC_chart_Info': 'ES No valid assets are available. Assets in this fund must have GRESB Sector and Country defined in order to be included in NZC calculations.',
    't_unable_to_plot_require_help': 'ES Please {contactEvora} if you require help.',
    't_contact_Evora': 'ES contact Evora',
    't_Contact_Evora': 'ES Contact Evora',
    't_model_no_data_available': 'ES No data available',
    't_select_target_pathway': 'ES Select Target Pathway',
    't_define_target_pathway': 'ES Define a custom target pathway',
    't_name_must_not_exceed_100_characters': 'ES The model name must not contain more than 100 characters',
    't_no_meter_information': 'ES No meter information.',
    't_no_assets': 'ES 0 assets',
    't_show_stranding_dates': 'ES Show CRREM Misalignment dates',
    't_default': 'ES Default',
    't_current_model': 'ES Current model',
    't_based_on': 'ES Based on',
    't_past_3_months': 'ES Past 3 months',
    't_past_6_months': 'ES Past 6 months',
    't_current_year_till_previous_month': 'ES Current year till previous month',
    't_model_with_same_name_exists': 'ES Model with the same name already exists.',
    't_apply_filter_view_these_assets': 'ES Apply Filter to view these assets',
    't_session_expiry': 'ES Your session is going to expire soon. Would you like to log out?',
    't_session_expiry_warning': 'ES For security reasons, we\'ll log you out in {0} unless you want to stay logged in.',
    't_session_expiry_title': 'ES Do you want to stay logged in?',
    't_stay_logged_in': 'ES Stay logged in',
    't_log_out_now': 'ES Log out now',
    't_jpeg': 'ES JPEG',
    't_svg': 'ES SVG',
    't_currency': 'ES Currency',
    't_nzc_session_model_deleted': 'ES {0} was deleted and cannot be displayed.  You are now viewing the default NZC model instead.',
    't_estimated_savings': 'ES Estimated Savings',
    't_procured_by': 'ES Procured by',
    't_area_covered': 'ES Area Covered',
    't_shared_services': 'ES Shared services',
    't_scope_index': 'ES Scope {0}',
    't_import_model_explanation_note_link': 'ES To import asset data from Excel you must use the {link} template.',
    't_import_model_explanation_note_description': 'ES Uploaded data is only used in the new NZC model that is created - it does not overwrite any data currently in SIERA',
    't_import_model_explanation_note_foundName': 'ES You can only upload data for assets that belong to the {fundOrAssetName} fund',
    't_btn_add': 'ES Add',
    't_btn_update_and_add': 'ES Update and add',
    't_gresb_measure_water': 'ES Performed a technical building assessment to identify water efficiency improvements',
    't_gresb_measure_waste': 'ES Performed a technical building assessment to identify waste efficiency improvements',
    't_gresb_measure_energy': 'ES Performed a technical building assessment to identify energy efficiency improvements',
    't_nzc_data_availability': 'ES Data availability',
    't_valid_ratings_by_floor_area': 'ES Valid scores by floor area',
    't_certified_assets_by_floor_area': 'ES Certified assets by floor area',
    't_ratings_last_sync_on': 'ES Scores last synced on {0}',
    't_certified': 'ES certified',
    't_energy_star_analysis': 'ES Energy Star Analysis',
    't_energy_star_score': 'ES Energy Star Score',
    't_energy_star_last_synced': 'ES This score was last synced from Energy Star Portfolio Manager on {0}.',
    't_kg_co2_m2_yr': 'ES kgCO₂e/m²/yr',
    't_kg_co2_yr': 'ES kgCO₂e/yr',
    't_kWh_m2_yr': 'ES kWh/m²/yr',
    't_energy_star_set': 'ES Set up your Energy Star integration to get this data',
    't_post_note_warning_message': 'ES Hit Post to add your note before closing',
    't_energy_star_integration': 'ES Energy Star Integration',
    't_es_sub_text': 'ES Integrating SIERA with your Energy Star Portfolio Manager will allow SIERA to extract and display energy ratings for your Assets.',
    't_learn_more': 'ES Learn more',
    't_es_step_title': 'ES Step {0} of {1}: {2}',
    't_es_step_one': 'ES Log into ES Portfolio Manager and add Evora_Siera as a contact',
    't_es_step_two': 'ES Enter your ES Portfolio Manager account ID',
    't_es_step_three': 'ES Share properties in ES Portfolio Manager with full access',
    't_es_step_four': 'ES Choose which Assets to extract ratings for',
    't_es_step_one_sub_text': 'ES {0} and add Evora_Siera as a new contact.',
    't_es_login_pf_manager': 'ES Log into your Energy Star Portfolio Manager',
    't_es_prompted_username': 'ES When prompted, enter “Evora_Siera” as the username.',
    't_es_add_contact_button': 'ES I have added Evora_Siera as a contact',
    't_es_requested_account_text': 'ES {0}\'s Energy Star Portfolio Manager account has requested to connect with your SIERA account.',
    't_es_account_id': 'ES Enter your ES Portfolio Manager account ID. You can find this in your ES Portfolio Manager account settings.',
    't_es_confirm_connection': 'ES Confirm connection',
    't_es_not_recognise_request': 'ES If you don\'t recognise this request, please select cancel.',
    't_es_account_sharing': 'ES Head back to your Energy Star Portfolio Manager account and go to {0}.',
    't_es_sharing': 'ES Sharing',
    't_es_select_share': 'ES Select \'share with your utility or service provider\' and share properties with SIERA.',
    't_es_set_props_full_access': 'ES Please ensure you are setting properties to full access.',
    't_es_i_have_set_up_sharing': 'ES I have set up sharing',
    't_es_available_assets': 'ES These are available Assets we found matches for in your Energy Star Portfolio Manager account. Please select the Assets you would like to extract ratings for and check that our suggested match is correct.\n',
    't_es_change_permission_and_support': 'ES If you do not see an Asset you would like to import data for, you may need to change permissions in your ES Portfolio Manager account or {0}. ',
    't_es_contact_support': 'ES Contact Support',
    't_es_confirm': 'ES Confirm',
    't_es_asset_in_siera': 'ES Asset in SIERA',
    't_es_asset_in_portfolio_manager': 'ES Respective Asset in ES Portfolio Manager',
    't_es_success': 'ES You can now view the Energy Star ratings for successfully matched Assets in SIERA.',
    't_success': 'ES Success',
    't_continue': 'ES Continue',
    't_action_based_pathway_stranding': 'ES Action-based pathway CRREM Misalignment in',
    't_fund_carbon_intensity': 'ES Fund carbon intensity',
    't_fund_energy_intensity': 'ES Fund energy intensity',
    't_es_step_three_error': 'Error: ES We couldn\'t find shared properties from your ES Porfolio Manager account.\n Please make sure you have set up sharing with full access.',
    't_es_step_two_error': 'Error: ES We couldn\'t find a request from the account ID you entered.\n Please check the ID is correct and try again.',
    't_es_step_one_error': 'Error: ES Please make sure you have added SIERA as a contact before proceeding.',
    't_es_api_error': 'Error: ES Contacting the Energy Star Portfolio Manager is not possible at the moment. Please try again later.\n If the error continues to happen, please contact support.',
    't_year_from_to_4_digits': 'ES Ensure year To is not less than year From (Please note 4 digits must be entered in these boxes)',
    't_min_max_numeric': 'ES Ensure maximum value is greater than minimum value (Numeric only)',
    't_es_matched_assets_info': 'ES These are the Assets in your SIERA account that have been matched with properties in your Energy Star Portfolio Manager. You can view Energy Star Ratings for these Assets in SIERA.',
    't_es_matched_assets_count': 'ES {0} of {1} Assets matched',
    't_es_sync_frequency': 'ES Sync frequency',
    't_es_match_more_assets': 'ES Match more Assets',
    't_address': 'ES Address',
    't_last_sync': 'ES Last Sync',
    't_jpeg_small': 'ES Small JPEG',
    't_png_small': 'ES Small PNG',
    't_jpeg_medium': 'ES Medium JPEG',
    't_png_medium': 'ES Medium PNG',
    't_jpeg_large': 'ES Large JPEG',
    't_png_large': 'ES Large PNG',
    't_max_length_30': 'ES Custom pathway maximum character length is 30 characters',
    't_unique_pathway_name': 'ES The custom pathway name must be unique',
    't_tp_name_validation': 'ES Name can only contain numbers & letters',
    't_monthly': 'ES Monthly',
    't_yearly': 'ES Yearly',
    't_mean_carbon_intensity': 'ES Mean carbon intensity',
    't_data_availability_assets': 'ES Data availability of assets',
    't_uplifted': 'ES Uplifted',
    't_benchmark': 'ES Benchmarked',
    't_target_pathway_2': 'ES Target Pathway 2',
    't_target_pathway_3': 'ES Target Pathway 3',
    't_unique_custom_target_pathway_name': 'ES Custom pathway name must be unique',
    't_tp_name_empty': 'ES Custom pathway name cannot be empty',
    't_example': 'ES E.g.',
    't_no_assets_to_match': 'ES No assets to match.',
    't_intensity': 'ES Intensity',
    't_portfolio_excel': 'ES SIERA Portfolio.xlsx',
    't_excel_tab_name': 'ES Assets Raw Data',
    't_client_name': 'ES Client',
    't_agent_name': 'ES Agent',
    't_purchase_date': 'ES Purchase date',
    't_sale_date': 'ES Sale date',
    't_property_status': 'ES Property Status',
    't_gresb_sector': 'ES GRESB sector',
    't_energy_star_sector': 'ES Energy Star sector',
    't_select_energy_star_sector': 'ES Select Energy Star sector',
    't_gresb_management_status': 'ES GRESB management status',
    't_gia_m_sqrt': 'ES GIA (m2)',
    't_nla_m_sqrt': 'ES NLA (m2)',
    't_cpa_m_sqrt': 'ES CPA (m2)',
    't_is_cpa_estimated': 'ES Is CPA estimated?',
    't_gas_expected': 'ES Gas expected',
    't_water_expected': 'ES Water expected',
    't_electricity_expected': 'ES Electricity expected',
    't_oil_expected': 'ES Oil expected',
    't_district_heating_expected': 'ES District heating expected',
    't_district_cooling_expected': 'ES District cooling expected',
    't_fund_performance_excel': 'ES SIERA Fund Performance.xlsx',
    't_view_nzc_tp_for_asset': 'ES View detailed NZC pathways for this asset',
    't_fund_carbon_performance_report': 'ES Fund Carbon Performance Report',
    't_fund_electricity_performance_report': 'ES Fund Electricity Performance Report',
    't_fund_thermals_performance_report': 'ES Fund Gas, Fuels & Thermals Performance Report',
    't_fund_waste_performance_report': 'ES Fund Waste Performance Report',
    't_fund_water_performance_report': 'ES Fund Water Performance Report',
    't_fund_level_summary': 'ES Fund Level Summary',
    't_total_consumption_excel': 'ES Total Consumption (MWh)',
    't_asset_level_total_consumption_excel': 'ES Total Consumption ({0})',
    't_total_emission_excel': 'ES Total Emissions ({0})',
    't_total_consumption': 'ES Total Consumption ({0})',
    't_total_carbon_emission_excel': 'ES Total Carbon Emission (T)',
    't_gap_filled_data_excel': 'ES Gap Filled Data (%)',
    't_over_under_target_excel': 'ES Over/Under target (%)',
    't_time_period_excel': 'ES Time Period',
    't_asset_information_excel': 'ES Asset Information',
    't_floor_area_excel': 'ES Floor Area (m2)',
    't_floor_area_excel_imperial': 'ES Floor Area (ft2)',
    't_occupancy_excel': 'ES Occupancy (%)',
    't_intensity_excel': 'ES Intensity ({0})',
    't_carbon_intensity_excel': 'ES Carbon intensity ({0})',
    't_recycled_waste_excel': 'ES Recycled Waste (t)',
    't_total_waste_excel': 'ES Total Waste (t)',
    't_recycled_percentage_excel': 'ES % Recycled',
    't_recycled_percentage_change_excel': 'ES % change in recycled waste',
    't_post_code': 'ES Post code',
    't_interim_target': 'ES Interim target',
    't_month_to_end_of': 'ES month to end of', // to be updated
    't_months_to_end_of': 'ES months to end of', // to be updated
    't_energy_intensity_excel': 'ES Energy Intensity (m3/m2)',
    't_title_update_target_pathway_failed': 'ES Update target pathway failed',
    't_title_delete_target_pathway_failed': 'ES Delete target pathway failed',
    't_ton_co2_yr': 'ES tCO₂e/yr',
    't_average_carbon_intensity': 'ES Average Carbon intensity',
    't_average_energy_intensity': 'ES Average Energy intensity',
    't_average_cost_intensity': 'ES Average Cost intensity',
    't_performance_assets_model': 'ES Performance for assets used in model',
    't_energy_intensity_nzc': 'ES Energy intensity',
    't_selected_utility_excel': 'ES {0} - EXCEL',
    't_all_utilities_excel': 'ES All utilities - EXCEL',
    't_gas_fuels_thermals': 'ES Gas, fuels and thermals',
    't_total_energy_consumption': 'ES Total energy consumption (MWH)',
    't_fund_performance_report': 'ES Fund Performance Report',
    't_energy_summary': 'ES Energy Summary',
    't_remove_match': 'ES Remove match',
    't_remove': 'ES Remove',
    't_action_by_impact_excel': 'ES Actions by impact - EXCEL',
    't_action_by_status_excel': 'ES Actions by status - EXCEL',
    't_es_reset_warning_message_one': 'ES Cancelling will take you back to Step 1.',
    't_es_reset_warning_message_two': 'ES Are you sure you want to cancel the integration {0} set up process?',
    't_es_reset_warning_header_message': 'ES Cancel integration set up process',
    't_es_reset_warning_yes': 'ES Yes, cancel',
    't_es_reset_warning_no': 'ES Stay on step 4',
    't_tenant_data_quality': 'ES Tenant data quality',
    't_landlord_data_quality': 'ES Landlord data quality',
    't_tenant_procured_assets': 'ES Tenant procured assets',
    't_landlord_procured_assets': 'ES Landlord procured assets',
    't_actual_percentage': 'ES Actual (%)',
    't_supplier_estimated_percentage': 'ES Supplier estimated (%)',
    't_incomplete_percentage': 'ES Incomplete (%)',
    't_not_covered_percentage': 'ES Not covered (%)',
    't_total_missing_percentage': 'ES Total missing (%)',
    't_managing_agent': 'ES Managing agent',
    't_portion_of_missing_fund_data_percentage': 'ES Portion of missing fund data (%)',
    't_dq_floor_area_landlord': 'ES Maximum landlord floor area ({0})',
    't_dq_floor_area_tenant': 'ES Maximum tenant floor area ({0})',
    't_dq_floor_area_without_data': 'ES Floor area for which you have no data ({0})',
    't_dq_floor_area': 'ES Floor area ({0})',
    't_fund_data_quality_excel': 'ES Fund Data Quality Excel',
    't_fund_data_quality_report': 'ES Fund Data Quality Report',
    't_upload_consumption_data': 'ES Upload consumption data',
    't_upload_action_plans': 'ES Upload action plans',
    't_action_plan_point_two': 'ES Upload actions data',
    't_consumption_upload_sub_text': 'ES Uploading consumption data will improve your data completeness scores and help you accurately track your sustainability goals. In order to upload consumption data to SIERA, the data needs to be in accordance with our data template. {0} about how to submit consumption data.',
    't_action_plan_sub_text': 'ES You can manage significant amount of data simultaneously by uploading or editing action plans in bulk. In order to upload consumption data to SIERA, the data needs to be in accordance with our data template. {0} about how to upload/edit action plans in bulk.',
    't_consumption_upload_template_point_one': 'ES Download and populate your consumption template',
    't_action_plan_upload_template_point_one': 'ES Generate and populate your template',
    't_consumption_upload_point_one_subtext': 'ES Populate the template with your consumption data. The template has been partially populated to help you get the data in the right place.',
    't_action_plan_upload_point_one_subtext': 'ES Populate the template with your list of actions. The template has been partially populated to help you get the data in the right place.',
    't_download_template': 'ES Generate template',
    't_upload_template': 'ES Upload template',
    't_action_plan_upload_point_two_subtext': 'ES When you upload your completed template, you will be guided through an error handling process.',
    't_consumption_upload_success_title': 'ES Data upload successful',
    't_consumption_upload_success_text_one': 'ES Consumption has been uploaded for {0} meters. Uploaded on {1} by {2}.',
    't_consumption_upload_success_text_two': 'ES Your data will be available to view on the performance pages within 15 minutes. We\'ll send you an email when it\'s ready.',
    't_action_upload_success_text_one': 'ES {0} action plans have been uploaded. Uploaded on {1} by {2}',
    't_action_upload_success_text_two': 'ES Your data will be available to view on each asset\'s action plan page. We\'ll send you an email when its ready',
    't_action_upload_single_asset_success_text_one': 'ES Actions has been uploaded for {0}. Uploaded on {1} by {2}',
    't_consumption_upload_error_title': 'ES Data upload unsuccessful',
    't_consumption_upload_error_text_one': 'ES We\'re sorry, something\'s gone wrong.',
    't_consumption_upload_error_text_two': 'ES Your upload has been unsuccessful. Please {0} or try again.',
    't_return_home': 'ES Return home',
    't_return_action':'ES Return to Actions',
    't_upload_bulk_consumption': 'ES Bulk add consumption',
    't_upload_bulk_action_plan': 'ES Bulk add/edit actions',
    't_upload_bulk_consumption_assets_warning_button_back': 'ES OK, back',
    't_upload_bulk_consumption_assets_warning_button_agree': 'ES Upload anyway',
    't_upload_bulk_consumption_assets_warning': 'ES You\'re about to upload consumption data to a very large list of assets. We would recommend filtering your asset list to make your upload template more manageable.',
    't_fund_action_plan_report': 'ES Action Plan Report',
    't_total_agreed_actions': 'ES Total agreed actions',
    't_un_costed_actions': 'ES Un-costed actions',
    't_unit_of_measurement': 'ES Unit of measurement',
    't_overdue_actions': 'ES Overdue actions',
    't_under_review_actions': 'ES Actions under review',
    't_fund_agreed_actions_summary': 'ES Fund level summary of agreed actions',
    't_fund_overdue_actions_summary': 'ES Fund level summary of overdue actions',
    't_fund_completed_actions_summary': 'ES Fund level summary of completed actions',
    't_fund_applicable_actions_summary': 'ES Fund level summary of applicable actions',
    't_fund_under_review_actions_summary': 'ES Fund level summary of actions under review',
    't_fund_action_plan_status_excel': 'ES Fund ActionPlan (by status)',
    't_no_fund_actions_with_status': 'ES This fund has no actions with this status',
    't_actions_per_year': 'ES Actions per year',
    't_asset_performance_excel': 'ES Asset performance EXCEL',
    't_gas_fuels_performance': 'ES Gas, Fuels & Thermals performance report',
    't_water_performance': 'ES Water performance report',
    't_waste_performance': 'ES Waste performance report',
    't_carbon_performance': 'ES Carbon performance report',
    't_asset_performance_export': 'ES Asset performance export from portfolio view',
    't_asset_gas_fuels_thermals': 'ES Gas, fuels & thermals',
    't_total_energy_consumption_kwh': 'ES Total energy consumption (KWH or MWH)',
    't_gap_filled_energy_data': 'ES Gap-filled energy data (%)',
    't_current_energy_consumption': 'ES Current energy consumption (KWH)',
    't_generate_your_template': 'ES Generate your consumption template',
    't_generate_your_action_plan_template': 'ES Generate your action plan template',
    't_asset_details_excel': 'ES Asset details EXCEL',
    't_no_data_to_export': 'ES No data available to export',
    't_total_carbon_emissions': 'Total Carbon Emissions ({0})',
    't_landlord_summary': 'ES Landlord summary',
    't_tenant_summary': 'ES Tenant summary',
    't_dq_floor_area_gia': 'ES Floor area ({0}) GIA',
    't_fund_action_plan_impact_excel': 'ES Fund ActionPlan (by impact)',
    't_total_actions_for_category': 'ES Total actions in this category',
    't_fund_actions_bio_diversity_impact_summary': 'ES Fund level summary of actions with biodiversity impact',
    't_fund_actions_building_performance_impact_summary': 'ES Fund level summary of actions with building performance impact',
    't_fund_actions_community_engagement_impact_summary': 'ES Fund level summary of actions with community engagement impact',
    't_fund_actions_energy_impact_summary': 'ES Fund level summary of actions with energy impact',
    't_fund_actions_governance_recommended_impact_summary': 'ES Fund level summary of actions with governance recommended impact',
    't_fund_actions_health_wellbeing_impact_summary': 'ES Fund level summary of actions with health & wellbeing impact',
    't_fund_actions_social_value_impact_summary': 'ES Fund level summary of actions with social value impact',
    't_fund_actions_tenant_engagement_impact_summary': 'ES Fund level summary of actions with tenant engagement impact',
    't_fund_actions_waste_impact_summary': 'ES Fund level summary of actions with waste recycling impact',
    't_fund_actions_water_impact_summary': 'ES Fund level summary of actions with water impact',
    't_fund_actions_other_impact_summary': 'ES Fund level summary of actions with other impact',
    't_actions_with_bio_diversity_impact_title': 'ES Actions with biodiversity impact',
    't_actions_with_building_performance_impact_title': 'ES Actions with building performance impact',
    't_actions_with_community_engagement_impact_title': 'ES Actions with community engagement impact',
    't_actions_with_energy_impact_title': 'ES Actions with energy impact',
    't_actions_with_governance_recommended_impact_title': 'ES Actions with governance recommended impact',
    't_actions_with_health_wellbeing_impact_title': 'ES Actions with health & wellbeing impact',
    't_actions_with_social_value_impact_title': 'ES Actions with social value impact',
    't_actions_with_tenant_engagement_impact_title': 'ES Actions with tenant engagement impact',
    't_actions_with_waste_impact_title': 'ES Actions with waste recycling impact',
    't_actions_with_water_impact_title': 'ES Actions with water impact',
    't_actions_with_other_impact_title': 'ES Actions with other impact',
    't_fund_level_energy_summary': 'ES Fund level energy summary',
    't_asset_information': 'ES Asset information',
    't_total_floor_area_m2': 'ES Total Floor Area (m2)',
    't_tenant_controlled_asset': 'ES Tenant Controlled Asset',
    't_current_year_carbon_emissions_kg': 'ES Current Year Carbon Emissions (kg)',
    't_current_year_energy_consumption_kwh': 'ES Current Year Energy Consumption (KWH)',
    't_previous_year_carbon_emissions_kg': 'ES Previous Year Carbon Emissions (kg)',
    't_previous_annual_consumption_kwh': 'ES Previous annual consumption (KWH)',
    't_intensity_unit': 'ES Intensity ({0})',
    't_benchmark_kwh/m2': 'ES Benchmark (kWh/m2)',
    't_benchmark_m3/m2': 'ES Benchmark (m3/m2)',
    't_landfill_unit': 'ES Landfill ({0})',
    't_incinerated': 'ES Incinerated ({0})',
    't_recycled_unit': 'ES Recycled ({0})',
    't_reuse_unit': 'ES Reuse ({0})',
    't_anaerobic_t': 'ES Anaerobic (t)',
    't_hazardous_t': 'ES Hazardous (t)',
    't_unknown_unit': 'ES Unknown ({0})',
    't_total_t': 'ES Total (t)',
    't_energy_performance_report': 'ES Energy Performance Report',
    't_electricity_performance_report': 'ES Electricity Performance Report',
    't_gas_fuels_thermals_report': 'ES Gas, Fuels & Thermals Performance Report',
    't_water_performance_report': 'ES Water Performance Report',
    't_waste_performance_report': 'ES Waste Performance Report',
    't_carbon_performance_report': 'ES Carbon Performance Report',
    't_unsaved_changes': 'ES Unsaved changes',
    't_unsaved_changes_message': 'ES Do you want to save the changes to the model before navigating away?',
    't_leave_without_saving': 'ES Leave without saving',
    't_save_and_leave': 'ES Save and leave',
    't_support_guides': 'ES Support Guides',
    't_release_notes': 'ES Release Notes',
    't_asset_performance_report': 'ES Asset Performance Report',
    't_is_the_asset_tenant': 'ES Is the asset tenant controlled?',
    't_current_consumption': 'ES Current consumption',
    't_current_year_gap': 'ES Current year gap filled Data (%)',
    't_previous_annual_consumption': 'ES Previous annual consumption',
    't_previous_year_gap': 'ES Previous Year Gap Filled Data (%)',
    't_unit_of_measurement_for_consumption': 'ES Unit of measurement for consumption',
    't_benchmark_name': 'ES Benchmark',
    't_unit_of_measurement_for_intensity': 'ES Unit of measurement for intensity',
    't_kwh_m2': 'ES kWh/m2',
    't_m3': 'ES m3',
    't_m3_m2': 'ES m3/m2',
    't_kg_co2_m2': 'ES kg CO2e/m2',
    't_current_total_waste': 'ES Current Total Waste (t)',
    't_current_recycled_waste': 'ES Current Recycled Waste (t)',
    't_current_recycled': 'ES Current % Recycled',
    't_previous_total_waste': 'ES Previous Total Waste (t)',
    't_previous_recycled_waste': 'ES Previous Recycled Waste (t)',
    't_previous_recycled': 'ES Previous % Recycled',
    't_agreed_and_applicable_actions': 'ES Agreed and applicable actions',
    't_generate_template_user_text': 'ES The following will specify how your template is pre-populated.\nDon\'t worry, you\'ll still be able to edit the spreadsheet as you\nsee fit.',
    't_type_of_record': 'ES Type of record',
    't_template_to_generate': 'ES Template to generate',
    't_time_period': 'ES Time period',
    't_time_period_user_text': 'ES The template will only include date ranges for gaps in your consumption data, within your specified time period',
    't_meters_included_template': 'ES Meters included in template',
    't_file_name': 'ES File name',
    't_include_inactive_meters': 'ES Include inactive meters',
    't_generate': 'ES Generate',
    't_landlord_procured_meters': 'ES Landlord procured meters',
    't_tenant_procured_meters': 'ES Tenant procured meters',
    't_both': 'ES Both',
    't_asset_action_plans_excel': 'ESAsset action plans EXCEL',
    't_asset_data_quality_excel': 'ESAsset data quality EXCEL',
    't_benchmark_line': 'ES Benchmark line',
    't_no_benchmark': 'ES No Benchmark',
    't_benchmark_office_ac': 'ES BBP REEB Office A/C Typical Practice',
    't_benchmark_sc_ac': 'ES BBP REEB Enclosed SC A/C Typical Practice',
    't_consumption_upload': 'ES consumption upload',
    't_action_upload': 'ES action upload',
    't_bulk_consumption_instruction_header': 'ES SIERA Consumption Data Upload Template',
    't_bulk_action_plan_instruction_header': 'ES SIERA Actions Plan Add in Bulk Template',
    't_bulk_action_plan_edit_instruction_header': 'ES SIERA Actions Plan Edit in Bulk Template',
    't_bulk_consumption_instruction_note': 'ES Please note:',
    't_bulk_consumption_instruction_one': 'ES The submission of consumption data will contribute to your data quality and data completeness scores.',
    't_bulk_consumption_instruction_two': 'ES In order to upload consumption to SIERA, please populate sheet 2 of this spreadsheet (labelled \'consumption loader\') with your consumption figures. Then, upload the spreadsheet to SIERA on the same page you found this template.',
    't_bulk_consumption_instruction_three': 'ES We have pre-populated some of the columns for you, to help you populate the template from your internal records. Please feel free to change or add new date ranges according to the dates you have consumption records for, but please do not add any new columns and do not edit the meter ID column as we need exact ID\'s to add consumption to those meters.',
    't_bulk_consumption_instruction_four': 'ES Green headers indicate mandatory fields, whereas blue headers indicate optional fields.',
    't_bulk_consumption_instruction_six': 'ES We have only included meters in the template which we do not have a full set of consumption data for. If for whatever reason you need to override existing consumption records, please enter the exact date range for the consumption you want to override.',
    't_bulk_consumption_instruction_five': 'ES This template does not allow you to edit meter or asset characteristics. You will only be able to upload consumption data. To make any changes to asset or meter characteristics, please get in touch with an EVORA consultant or customer support.',
    't_bulk_consumption_instruction_seven': 'ES If the meter you are trying to upload consumption for is not listed on the template, you may not have access to upload consumption for this meter, or it may not exist on the system. Please get in touch with an EVORA consultant or our customer service team if you need to add a new meter before you upload consumption for that meter.',
    't_bulk_consumption_instruction_eight': 'ES If you require extra guidance on what a field means, you can click on the column and see a description of what the system requires for that field.',
    't_bulk_action_plan_instruction_one': 'ES This template will allow you to bulk Add Action Plans.',
    't_bulk_action_plan_edit_instruction_one': 'ES This template will allow you to bulk edit Action Plans.',
    't_bulk_action_plan_instruction_two': 'ES In order to add Actions in bulk, please go to sheet called "Bulk Add Template" under this file with all the relevant actions.',
    't_bulk_action_plan_edit_instruction_two': 'ES In order to edit Actions in bulk, please go to sheet called "Bulk Edit Template" under this file with all the relevant actions.',
    't_bulk_action_plan_instruction_three': 'ES Asset Reference Column has a list of all your assets within the fund, select the one you want the action to added to, if you downloaded the template from an Asset you will only get the individual asset.',
    't_bulk_action_plan_instruction_four': 'ES Each row represents an action, to add multiple to the same asset please select the same "Asset Reference in a new row"',
    't_bulk_action_plan_instruction_five': 'ES Columns highlighed in green are required, blue are optional.',
    't_bulk_action_plan_instruction_six': 'ES Once populated please reupload the filled in file back into SIERA.',
    't_bulk_action_plan_instruction_seven': 'ES If you require further guidance on each of the fields, click the header of the column for more information.',
    't_bulk_consumption_tooltip_asset_name': 'ES This is the name of the asset. Don’t see an asset or meter you need to add consumption for? Contact SIERA team to add it to the system.',
    't_bulk_consumption_tooltip_utility': 'ES The utility type this meter is associated with.',
    't_bulk_action_plan_edit_tooltip_actionId': 'ES DO NOT EDIT THIS',
    't_bulk_consumption_tooltip_area_covered': 'ES The area of the property which this meter covers.',
    't_bulk_consumption_tooltip_is_active': 'ES Is this meter active or inactive',
    't_bulk_consumption_tooltip_serial_number': 'ES The meter’s serial number',
    't_bulk_consumption_tooltip_meter_name': 'ES The meter name in SIERA. This should match up with your internal notes, so you can easily find which meter this refers to.',
    't_bulk_consumption_tooltip_from_date': 'ES The start date of this consumption record, in the format dd/mm/yyyy. We have populated the dates for which we do not have consumption data in the system, but feel free to replace these dates if you do not have data for the full date range.',
    't_bulk_consumption_tooltip_to_date': 'ES The end date of the consumption record, in the format dd/mm/yyyy',
    't_bulk_consumption_tooltip_origin': 'ES The origin of the consumption figure, eg. invoices or meter readings',
    't_bulk_consumption_tooltip_consumption': 'ES Please enter your consumption. We cannot accept meter readings at this time. Remove any commas or decimal places. Energy must be in kWh and water in m3.',
    't_bulk_consumption_tooltip_estimated': 'ES Is this consumption figure estimated or actual',
    't_bulk_action_plan_tooltip_assetReference': 'ES Select the asset you would like to add the action to, each row represents an action. So if you want to add multiple actions to the same asset please ensure you select it for each row.',
    't_bulk_action_plan_tooltip_gresbefficiency': 'ES Please ensure you select the GRESB Efficiency Measure if you have selected any of the following Impacts: Energy, Water and Waste.',
    't_bulk_action_plan_tooltip_cost': 'ES Please just enter the amount without currency characters.',
    't_bulk_action_plan_tooltip_currency': 'ES Only applies to the following Impact Selections: Building Performance, Energy, Waste Recycling and Water',
    't_bulk_action_plan_tooltip_primaryUtilityType': 'ES Only applies to the following Impact Selections: Building Performance, Energy, Waste Recycling and Water',
    't_bulk_action_plan_tooltip_primaryUtilityChange': 'ES Please add the change in consumption. Add "-" before the number for a reduction or enter just the number for an increase in consumption',
    't_bulk_action_plan_tooltip_primaryUtilityCostChange': 'ES Enter the amount of cost changes, currency dropdown applies to these fields, so only the amounts will be necessary.',
    't_bulk_action_plan_tooltip_secondaryUtilityChange': 'ES Please add the change in consumption. Add "-" before the number for a reduction or enter just the number for an increase in consumption',
    't_import_model_explanation_note_asset_name': 'ES You can only upload data related to {fundOrAssetName} asset',
    't_evoranzcdata': 'ES EvoraNZCData',
    't_summary': 'ES Summary',
    't_asset_performance_excel_file_name': 'ES SIERA Asset Performance Excel',
    't_total_energy_consumption_excel_mwh': 'ES Total Energy Consumption (MWh)',
    't_total_energy_consumption_excel_kwh': 'ES Total Energy Consumption (kWh)',
    't_action_export_from_portfolio_view': 'ES Actions export from portfolio view',
    't_summary_of_agreed_action': 'ES Summary of agreed actions',
    't_total_overdue_action': 'ES Total overdue actions',
    't_total_completed_action': 'ES Total completed actions',
    't_total_applicable_action': 'ES Total applicable actions',
    't_total_action_under_review': 'ES Total actions under review',
    't_action_estimated_savings': 'ES Estimated savings',
    't_action_area_covered': 'ES Area covered',
    't_summary_of_overdue_action': 'ES Summary of overdue actions',
    't_summary_of_completed_actions': 'ES Summary of completed actions',
    't_summary_of_applicable_actions': 'ES Summary of applicable actions',
    't_summary_of_actions_under_review': 'ES Summary of actions under review',
    't_no_assets_selected_actions_status': 'ES The assets selected have no actions with this status',
    't_missing_fund_data_weighted_by_floor_area': 'ES Missing fund data, weighted by floor area (%)',
    't_floor_area_for_no_data': 'ES Floor area not covered ({0})',
    't_floor_area_not_covered_percentage': 'ES Floor area not covered (%)',
    't_portfolio_data_quality_report': 'ES Data Quality Report',
    't_portfolio_data_quality_file_name': 'ES Portfolio Data Quality Report',
    't_current_energy_consumption_kwh': 'ES Current Energy Consumption (kWh)',
    't_level_of_details_by_asset': 'ES By asset',
    't_level_of_details_by_meter': 'ES By meter',
    't_time_period_granularity_annual': 'ES Annual',
    't_time_period_granularity_monthly': 'ES Monthly',
    't_level_of_detail': 'ES Level of detail',
    't_time_period_granularity': 'ES Time period granularity',
    't_name_must_not_exceed_50_characters': 'ES The model name must not contain more than 50 characters',
    't_current_reporting_period_total_energy_consumption': 'ES Current Reporting Period Total Energy Consumption ({0})',
    't_current_reporting_gap_filled_energy_data_percentage': 'ES Current Reporting Gap-filled Energy Data (%)',
    't_previous_reporting_period_total_energy_consumption': 'ES Previous Reporting Period Total Energy Consumption ({0})',
    't_previous_reporting_gap_filled_energy_data_percentage': 'ES Previous Reporting Gap-filled Energy Data (%)',
    't_total_asset_floor_area': 'ES Total Asset Floor Area ()',
    't_reporting_period': 'ES Reporting Period',
    't_reporting_period_gap_filler_data_percentage': 'ES Reporting Period Gap Filled Data (%)',
    't_reporting_period_carbon_emissions': 'ES Reporting Period Carbon Emissions ({0})',
    't_current_reporting_period_total_consumption': 'ES Current Reporting Period Total Consumption ({0})',
    't_utility_meter_unavailable': 'ES Unavailable: no meter for',
    't_current_reporting_period_gap_filled_data_percentage': 'ES Current Reporting Period Gap Filled Data (%)',
    't_previous_reporting_period_total_consumption': 'ES Previous Reporting Period Total Consumption ({0})',
    't_previous_reporting_period_gap_filled_data_percentage': 'ES Previous Reporting Period Gap Filled Data (%)',
    't_current_reporting_period_total_waste': 'ES Current Reporting Period Total Waste ({0})',
    't_current_reporting_period_recycled_waste': 'ES Current Reporting Period Recycled Waste ({0})',
    't_current_percentage_recycled': 'ES Current % Recycled',
    't_previous_reporting_period_total_waste': 'ES Previous Reporting Period Total Waste ({0})',
    't_hazardous_waste': 'ES Hazardous Waste ({0})',
    't_non_hazardous_waste': 'ES Non-hazardous Waste ({0})',
    't_total_waste_generated': 'ES Total Waste Generated ({0})',
    't_waste_to_energy_unit': 'ES Waste to energy ({0})',
    't_waste_generated': 'ES Waste Generated',
    't_destination': 'ES Destination',
    't_current_reporting_period_total_emissions': 'ES Current Reporting Period Total Emissions ({0})',
    't_previous_reporting_period_total_emissions': 'ES Previous Reporting Period Total Emissions ({0})',
    't_previous_reporting_period_recycled_waste': 'ES Previous Reporting Period Recycled Waste ({0})',
    't_emissions': 'ES Emissions',
    't_current_total_carbon_emissions': 'ES Current total Carbon Emissions ({0})',
    't_scope_1_emissions': 'ES Scope 1 emissions ({0})',
    't_scope_2_emissions': 'ES Scope 2 emissions ({0})',
    't_scope_3_emissions': 'ES Scope 3 emissions ({0})',
    't_current_period_consumption_with_gapFilled_data': 'ES Current period consumption ({0})',
    't_current_period_gapFilled_data': 'ES Current period Gap Filled Data (%)',
    't_previous_period_consumption_with_gapFilled_data': 'ES Previous period consumption ({0})',
    't_previous_period_gapFilled_data': 'ES Previous period Gap Filled Data (%)',
    't_previous_period_total_carbon_emissions': 'ES Previous period\'s total carbon emissions ({0})',
    't_current_consumption_with_gapFilled_data': 'ES Current period consumption ({0})',
    't_current_energy_consumption_with_gapFilled_data': 'ES Current energy consumption ({0})',
    't_previous_energy_consumption_kwh_with_gapFilled_data': 'ES Previous energy consumption ({0})',
    't_import_file_error_message': 'ES The import file name must not contain more than 50 characters',
    't_no_export_data_available': 'ES The assets selected have no data available for this utility within the specified time frame.',
    't_current_reporting_period_gap_filled_energy_data_percentage': 'ES Current Reporting Period Gap-Filled Energy Data (%)',
    't_previous_reporting_period_gap_filled_energy_data_percentage': 'ES Previous Reporting Period Gap-Filled Energy Data (%)',
    't_meter_name': 'ES Meter name',
    't_serial_number': 'ES Serial number',
    't_comment': 'ES Comment',
    't_active_from': 'ES Active from',
    't_active_to': 'ES Active to',
    't_is_this_a_submeter': 'ES Is this a submeter?',
    't_floor_area_served_by_meter': 'ES Floor area served by Meter ({0})',
    't_green_tariff': 'ES Green tariff',
    't_current_annual_consumption_includes_gap_filled_data': 'ES Current annual consumption ({0}) (includes gap-filled data)',
    't_previous_year_total_consumption_includes_gap_filled_data': 'ES Previous year\'s total consumption ({0}) (includes gap-filled data)',
    't_floor_area_served': 'ES Floor area served ({0})',
    't_previous_periods_total_consumption_includes_gap_filled_data': 'ES Previous period\'s total consumption ({0}) (includes gap-filled data)',
    't_waste_disposal_route_reference': 'ES Waste disposal route reference',
    't_contractor': 'ES Contractor',
    't_waste_type': 'ES Waste Type',
    't_previous_period_carbon_emissions': 'ES Previous period carbon emissions ({0})',
    't_previous_periods_total_consumption_include_gap_filled_data': 'ES Previous period\'s total consumption ({0}) (includes gap-filled data)',
    't_meter_information': 'ES Meter Information',
    't_actions_date': 'Based on {0}',
    't_export_performance_excel': 'ES Export performance - EXCEL',
    't_water_intensity_excel': 'ES Water Intensity ({0})',
    't_export_data_quality_excel': 'ES Export data quality - EXCEL',
    't_current_consumption_with_excluding_gapFilled_data': 'ES Current consumption ({0}) (excluding gap-filled data)',
    't_previous_consumption_with_excluding_gapFilled_data': 'ES Previous period consumption ({0}) (excluding gap-filled data)',
    't_current_energy_consumption_with_excluding_gapFilled_data': 'ES Current energy consumption ({0}) (excluding gap-filled data)',
    't_previous_energy_consumption_kwh_with_excluding_gapFilled_data': 'ES Previous energy consumption ({0}) (excluding gap-filled data)',
    't_manage_es_integration_link': 'ES Manage Energy Star integration',
    't_assets_info_with_no_agreed_actions': 'ES In the current NZC model, {0} out of {1} assets have no agreed energy-saving actions.',
    't_assets_info_with_agreed_actions': 'ES In current NZC model, all {0} assets have at least one energy-saving action defined.',
    't_data_below_target': 'ES Data below target',
    't_gap_filled_data_below_target': 'ES Gap-filled data below target',
    't_data_above_target': 'ES Data above target',
    't_gap_filled_data_above_target_updated': 'ES Gap-filled data above target',
    't_data_below_previous_period': 'ES Data below previous period',
    't_gap_filled_data_below_previous_period': 'ES Gap-filled data below previous period',
    't_data_above_previous_period': 'ES Data above previous period',
    't_gap_filled_data_above_previous_period': 'ES Gap-filled data above previous period',
    't_carbon_scope_info': '<p><b>ES Scope 1: </b>Carbon emissions from landlord gas and oil</p> <p><b>Scope 2: </b>Carbon emissions from landlord electricity, district heating and district cooling</p> <p><b>Scope 3: </b>Carbon emissions from tenant energy usage</p> ',
    't_data_quality_info': 'ES Reports can be compiled with any level of Data Quality using gap-filling, but this will affect the accuracy of your outputs. We recommend using the Data Quality page to increase the completeness of your data.',
    't_industry_standard_benchmark': 'ES Industry standard benchmark ({0})',
    't_variance_against_industry_standard_benchmark': 'ES Variance against Industry Standard Benchmark (%)',
    't_asset_nzc_action_based_target_pathway_info': 'ES Action-based pathways aggregate all of the energy-saving actions that have been defined in the current model and present them as a single pathway.',
    't_asset_nzc_custom_based_target_pathway_info': 'ES Custom target pathways allow you to specify your own targets over time for this asset in your model.',
    't_kwh_m2_yr': 'ES kWh/m²/yr',
    't_assets_with_scores': 'ES Assets with scores',
    't_gav_coverage': 'ES GAV coverage',
    't_date_completed': 'ES Date completed',
    't_total_emissions': 'ES Total Emissions',
    't_scope1_emissions': 'ES Scope 1 Emissions',
    't_scope2_emissions': 'ES Scope 2 Emissions',
    't_scope3_emissions': 'ES Scope 3 Emissions',
    't_missing_fund_data_weighted': 'ES Missing fund data, weighted by floor area (%)',
    't_commercial': 'ES Commercial',
    't_no_data_for_comparison': 'ES No data for comparison',
    't_landlord_tenant_split': 'ES Landlord/Tenant split',
    't_scope_breakdown': 'ES Scope breakdown',
    't_scope1_landlord': 'ES Scope 1 (Landlord)',
    't_scope2_landlord': 'ES Scope 2 (Landlord)',
    't_scope3_tenant': 'ES Scope 3 (Tenant)',
    't_scope1': 'ES Scope 1',
    't_scope2': 'ES Scope 2',
    't_scope3': 'ES Scope 3',
    't_net_change': 'ES Net change',
    't_required_asset_ref': 'ES Asset Reference *',
    't_impact_type': 'ES Impact (Type) *',
    't_gresb_efficiency_measure': 'ES GRESB Efficiency Measure',
    't_required_status': 'ES Status *',
    't_action_plan_title': 'ES Action Plan Title * (Max 50 Characters)',
    't_required_area_covered': 'ES Area Covered *',
    't_required_currency': 'ES Currency * \r\n(Required if applicable)',
    't_required_primary_utility_type': 'ES Primary Utility Type * \r\n(Required if applicable)',
    't_required_primary_utility_change': 'ES Primary Utility Change * \r\n(Required if applicable)',
    't_required_primary_utility_cost_change': 'ES Primary Utility Cost Change * \r\n(Required if applicable)',
    't_secondary_utility_type': 'ES Secondary Utility Type',
    't_secondary_utility_change': 'ES Secondary Utility Change',
    't_required_action_id': 'ES Action ID * \r\nDO NOT EDIT',
    't_active_inactive': 'ES Active / inactive',
    't_required_meter_pan': 'ES Meter name  / MPAN *',
    't_required_meter_id': 'ES Meter ID *',
    't_required_from_date': 'ES From date *',
    't_required_to_date': 'ES To date *',
    't_required_consumption': 'ES Consumption (Energy in kWh, Water in m3) *',
    't_required_estimate_actual': 'ES Estimated/actual *',
    't_required_origin': 'ES Origin *',
    't_scheduled_date': 'ES Scheduled date',
    't_estimated_change': 'ES Estimated change',
    't_find_action': 'ES Find action',
    't_filters': 'ES Filters',
    't_btn_request_consumption': 'ES Request consumption',
    't_header_request_consumption': 'ES Request Consumption',
    't_additional_information': 'ES Additional Information',
    't_serial_number_consumption': 'ES Serial Number',
    't_utility_type_consumption': 'ES Utility Type',
    't_area_covered_consumption': 'ES Area Covered',
    't_meter_status': 'ES Meter Status',
    't_submeter': 'ES Submeter',
    't_all_categories': 'ES All categories',
    't_estimated_data': 'ES Estimated data',
    't_delete_record': 'ES Delete record',
    't_delete_records': 'ES Delete records',
    't_edit_record': 'ES Edit record',
    't_edit_records': 'ES Edit records',
    't_add_consumptions': 'ES Add consumption',
    't_asset_procurement_data_categories': 'ES <p><b>Actual:</b> Consumption data entered for a meter.</p> <p><b>Estimated:</b> meter data derived from supplier estimates (e.g. from invoices).</p> <p><b>Incomplete:</b> where a meter for a building area has been set up but is missing data for one or more time periods (this is a measure of time).</p> <p><b>Not covered:</b> where we have no information about meters in a given part of a building for a given utility, but we believe this utility is being consumed (this is a measure of floor area). These areas are always assumed to be tenant-procured rather than landlord-procured, except for landlord-controlled assets where no meters have been added.</p> <p><b>Missing:</b> the combination of \'Incomplete\' and \'Not covered\'.</p>',
    't_request_email_label': 'ES Recipients (separate emails with commas)',
    't_request_email_placeholder': 'ES Add email recipients',
    't_request_send_button': 'ES Send request email',
    't_email_sent_confirmation': 'ES Email sent',
    't_select_utility': 'ES Select Utility',
    't_utilities': 'ES Utilities',
    't_clear_all': 'ES Clear all',
    't_select_status': 'ES Select status',
    't_select_impact': 'ES Select impact',
    't_select_cost_type': 'ES Select cost type',
    't_select_scope': 'ES Select scope',
    't_select_procurement': 'ES Select procurement',
    't_search_meter_placeholder': 'ES Search meter name...',
    't_no_meter_data_available': 'ES This meter has no data available within the specified time frame',
    't_select_all': 'ES Select All',
    't_error_title': 'ES Error',
    't_delete_warn': 'ES Are you sure you want to delete this record?',
    't_delete_warn_s': 'ES Are you sure you want to delete these records?',
    't_delete_yes': 'ES Yes, delete',
    't_cancel_delete': 'ES No, cancel',
    't_no_export_data_available_for_single_asset': 'ES The asset selected have no data available for this utility within the specified time frame.',
    't_origin': 'ES Origin',
    't_submitted_by': 'ES Submitted by',
    't_gap_filled_scope': 'ES gap-filled',
    't_procured_data': 'ES procured data',
    't_meter_submitted_by': 'ES Submitted By',
    't_action_plan_improvement_sub_text': 'ES Recording action plans enables you to track improvement opportunities at your assets. You can manage a significant amount of data simultaneously by uploading or editing action plans in bulk. In order to upload action plans to SIERA, the data needs to be in accordance with our data template.',
    't_nzc_available_not_siera': 'ES Net Zero Carbon module not available.',
    't_action_details': 'ES Action details',
    't_action_details_description': 'ES Key information associated with actions regarding how the Impact influences GRESB efficiency measures with Area coverage',
    't_estimated_actual_required': 'ES Estimated or Actual *',
    't_action_information': 'ES Action information',
    't_action_title': 'ES Action title',
    't_action_impact_error_message': 'ES Please select a impact',
    't_action_title_error_message': 'ES Please select a title',
    't_action_status_error_message': 'ES Please select a status',
    't_current_consumption_with_gapFilled': 'ES Current consumption ({0})',
    't_previous_consumption_with_gapFilled_data': 'ES Previous period consumption ({0})',
    't_consumption_information': 'ES Consumption Information',
    't_add_consumption_title': 'ES Add Consumption',
    't_edit_record_title': 'ES Edit Record',
    't_edit_records_title': 'ES Edit Records',
    't_update_record': 'ES Update Record',
    't_update_records': 'ES Update Records',
    't_update_record_confirmation': 'ES Record updated',
    't_update_records_confirmation': 'ES Records updated',
    't_submit_consumption': 'ES Submit consumption',
    't_submit_confirmation': 'ES Consumption added',
    't_associated_costs_utility': 'ES Associated costs and Utility',
    't_associated_costs_utility_desc': 'ES The savings per utility type and its cost. Negative value shows greater savings reduction and a positive value shows an increase',
    't_cost_of_action': 'ES Cost of action',
    't_select_currency': 'ES Select currency',
    't_action_currency_error_message': 'ES Please select a currency',
    't_action_title_error_msg': 'ES Please add a title',
    't_nodata_for_timeperiod': 'ES There is no data available for this time period',
    't_back_to_list': 'ES Back to List',
    't_add_data': 'ES Add Data',
    't_edit_data': 'ES Edit Data',
    't_select_area_covered': 'ES Select area covered',
    't_action_area_covered_error_message': 'ES Please select the area covered',
    't_gresb_efficiency_measure_select': 'ES Select GRESB efficiency measure',
    't_gresb_efficiency_measure_error_msg': 'ES Please select a GRESB efficiency measure',
    't_cooling_tower_drip': 'ES Cooling tower Drip / Smart irrigation',
    't_onsite_waste_water_treatment_reuse_of_storm_water': 'ES On-site waste water treatment / Reuse of storm water / Grey water',
    't_building_specific_communication': 'ES Building specific communication (i.e. posters, emails or newsletters)',
    't_feedback_sessions_individual_tenants': 'ES Feedback sessions with individual tenants - e.g. discussing sustainability requirements',
    't_social_media_online_platform': 'ES Social media / Online platform',
    't_tenant_meetings_which_includes': 'ES Tenant meetings which includes sustainability',
    't_tenant_sustainability_events': 'ES Tenant sustainability events',
    't_tenant_sustainability_guide': 'ES Tenant sustainability guide',
    't_tenant_sustainability_training': 'ES Tenant sustainability training',
    't_Tenants_feedback_energy_water_waste': 'ES Tenants receive feedback on energy, water or waste performance',
    't_gap_filled_split': 'ES Gap-filled',
    't_action_scheduled_completion_date': 'ES Scheduled completion date',
    't_action_completion_date': 'ES Completion date',
    't_select_primary_utility': 'ES Select primary utility',
    't_select_secondary_utility': 'ES Select secondary utility',
    't_primary_utility': 'ES Primary utility',
    't_secondary_utility': 'ES Secondary utility',
    't_primary_utility_error_message': 'ES Please select a primary utility',
    't_primary_utility_cost_error_msg': 'ES Please enter a change',
    't_choose_breakdown': 'ES Choose breakdown',
    't_modified_date': 'ES Modified date',
    't_gap_filling': 'ES Gap-filling',
    't_sold_badge_label': 'ES Sold in',
    't_view_detailed_dq_break_down': 'ES View detailed Data Quality breakdown',
    't_gresb_not_mandatory': 'ES GRESB efficiency measure selection is not mandatory but recommended',
    't_required_asset_name': 'ES Asset Name *',
    't_purchased': 'ES Purchased',
    't_nzc_sold': 'ES Sold',
    't_edit_asset': 'ES Edit asset',
    't_back_action_plan': 'ES Back to Action Plan',
    't_key_metrics': 'ES Key Metrics',
    't_payback_period': 'ES Payback period',
    't_matched_assets_count': 'ES {0} assets selected, please match the remaining assets',
    't_search_by_asset': 'ES Search by asset name',
    't_select_available_match': 'ES Select from {0} available matches',
    't_fund_sfdr_pai_report': 'ES SFDR PAI Report',
    't_y_o_y_trend': 'ES Year-on-Year Trend',
    't_adverse_sustainability_impact': 'ES Adverse Sustainability Impact',
    't_tonnes_co2e': 'ES tonnes CO2e',
    't_ghg_scope1': 'ES Scope 1 GHG emissions generated by real estate assets',
    't_ghg_scope2': 'ES Scope 2 GHG emissions generated by real estate assets',
    't_ghg_scope3': 'ES Scope 3 GHG emissions generated by real estate assets',
    't_ghg_scope_total': 'ES Total GHG emissions generated by real estate assets',
    't_including_estimates': 'ES Including estimates',
    't_actual_only': 'ES Actual Only',
    't_percentage': 'ES Percentage',
    't_vertical': 'ES Vertical',
    't_horizontal': 'ES Horizontal',
    't_fossil_fuels': 'ES Fossil Fuels',
    't_adverse_impact_ghg_emissions_by_scope': 'ES GHG emissions by scope',
    't_gia_tooltip_content': 'ES This is the total internal floor area associated with the asset and should equal the NLA and CPA.',
    't_nla_tooltip_content': 'ES This is the floor area associated with the lettable space only ( e.g. office or retail space) and excludes communal areas.',
    't_cpa_tooltip_content': 'ES This is the area associated with communal spaces such as reception areas, lift lobbies, stairwells and shared toilets.',
    't_ext_tooltip_content': 'ES This is the area associated with external areas such as car parks.',
    't_effect_on_utilities': 'ES Effect on utilities',
    't_single_year': 'ES year',
    't_multiple_years': 'ES years',
    't_gia_nla_required_message': 'ES Please ensure at least one field (GIA or NLA) is filled in',
    't_gia_nla_cpa_ext_length_validation_message': 'ES Amount entered is low. Please verify before continuing',
    't_gia_nla_cpa_adding error': 'ES Please ensure the values for the NLA and CPA equal the GIA',
    't_date_required': 'ES Please enter a date',
    't_future_year_error':'ES The year built can not be in the future',
    't_past_year_error' :'ES Year Built should be greater than 1800',
    't_invalid_year_error':'ES Invalid year format. Please enter a valid year',
    't_future_date_error': 'ES Date cannot be in the future',
    't_sale_date_error': 'ES Sale date must be after the purchase date',
    't_sale_date_before_purchase_date_error': 'ES Please enter the purchase date',
    't_post_note': 'ES Post a note',
    't_clear_note': 'ES Clear note',
    't_higher_than_target': 'ES higher than target',
    't_lower_than_target': 'ESlower than target',
    't_higher_than_previous_period': 'ES higher than previous period',
    't_lower_than_previous_period': 'ES lower than previous period',
    't_date_created': 'ES Date created',
    't_created_by': 'ES Created by',
    't_gresb_sector_tooltip': 'ES Select the sub type that best represents your asset , as per the  GRESB standard.',
    't_energy_star_sector_tooltip': 'ES Select the relevant sector from Energy Star categories that best describes your asset\'s industry for energy performance tracking and benchmarking.',
    't_operation_control_landlord_controlled_tooltip': 'ES {dynamic}: The Landlord has complete or partial ability to change operating policies, environmental policies and the purchase of utilities.',
    't_operation_control_tenant_controlled_tooltip': 'ES {dynamic}: Only the Tenant(s) have control over operating policies, environmental policies and the purchase of utilities.',
    't_please_select_option_from_dropdown': 'ES Please select an option from the dropdown',
    't_sync_success_message': 'ES Sync complete',
    't_notes_in_actions_not_saved': 'ES Do you want to save the changes to the action before navigating away?',
    't_select_the_country_of_asset': 'ES Select the country of the asset',
    't_select_the_region_of_asset': 'ES Select the region of the asset',
    't_enter_asset_name': 'ES Please Enter Asset Name',
    't_validation_asset_name': 'ES Asset name already exists. Choose a different name',
    't_validation_asset_reference': 'ES Asset reference already exists. Choose a different reference',
    't_enter_asset_reference': 'ES Please Enter Asset Reference',
    't_select_assetdetails_fund': 'ES Select a fund',
    't_asset_ownership_invalid_input': 'ES Invalid input. Please enter a numeric percentage value',
    't_asset_ownership_required': 'ES Please enter a Fund Ownership %',
    't_asset_ownership_min_value': 'ES Range should be between 1-100',
    't_asset_ownership_max_value': 'ES Range should be between 1-100',
    't_documents': 'ES Documents',
    't_pai_selection': 'ES PAI selection',
    't_real_estate_mandatory': 'ES Mandatory for Real Estate',
    't_select_at_least': 'ES Select at least one from below',
    't_operational_control_asset': 'ES Select the Operational Control for the asset',
    't_select_at_least_one_option': 'ES Please select at least one option from the dropdown',
    't_warning_gas_district_heating': 'ES Gas and district heating selected. Is this correct?',
    't_warning_gas_district_cooling': 'ES Gas and district cooling selected. Is this correct?',
    't_warning_gas_district_heating_and_district_cooling': 'ES Gas and district heating/district cooling selected. Is this correct?',
    't_enter_date_of_evaluation': 'ES Enter the date of this last evaluation',
    't_keyfacts': 'ES Key Facts',
    't_performance_overview': 'ES Performance overview',
    't_variance_against_target': 'ES Variance against target',
    't_variance_against_previous_period': 'ES Variance against previous period',
    't_below': 'ES below',
    't_above': 'ES above',
    't_gap_filled_data_not_applicable': 'ES gap-filled data not applicable',
    't_documents_n_certificates': 'ES Documents & Certificates',
    't_consumption_evidence': 'ES Consumption Evidence',
    't_filter_applied': 'ES {0} filter applied.',
    't_filters_applied': 'ES {0} filters applied.',
    't_download_documents': 'ES Download documents',
    't_top_down_pathways': 'ES Top-Down pathways',
    't_upload_top_down_pathways': 'ES Upload top-down pathways',
    't_pai_report': 'ES PAI Report',
    't_fossil_fuel_impact_report': 'ES Fossil Fuel Exposure Impact Report',
    't_energy_efficiency_impact_report': 'ES Energy Efficiency Impact Report',
    't_ghg_impact_report': 'ES GHG Emissions Impact Report',
    't_energy_consumption_impact_report': 'ES Energy Consumption Impact Report',
    't_waste_impact_report': 'ES Waste Management Impact Report',
    't_resource_consumption_impact_report': 'ES Resource Consumption Impact Report',
    't_biodiversity_impact_report': 'ES Biodiversity Impact Report',
    't_quarterly_summary': 'ES Quarterly Summary',
    't_exposed_value': 'ES Exposed Value',
    't_total_applicable_value': 'ES Total Applicable Value',
    't_total_excluded_value': 'ES Total Excluded Value',
    't_share_applicable_value_exposed': 'ES Share of applicable value exposed',
    't_share_total_value_excluded': 'ES Share of total value excluded',
    't_principle_metrics': 'ES Principle Metrics',
    't_average_share_exposed_value': 'ES Average share of exposed value',
    't_average_share_total_value_excluded': 'ES Average share of total value excluded',
    't_ped_below_nzeb': 'ES PED below NZEB?',
    't_total_portfolio_value': 'ES Total Portfolio Value',
    't_construction_year': 'ES Construction Year',
    't_total_scope1_emissions': 'ES Total Scope 1 Emissions',
    't_total_scope2_emissions': 'ES Total Scope 2 Emissions',
    't_total_scope3_emissions': 'ES Total Scope 3 Emissions',
    't_total_ghg_emissions': 'ES Total GHG Emissions',
    't_actual_data_only': 'ES Actual data only',
    't_including_estimations': 'ES Including estimations',
    't_exposed_value_share': 'ES Share of exposed value',
    't_inefficient_re': 'ES Inefficient RE',
    't_overview': 'ES Overview',
    't_ghg': 'ES GHG',
    't_ghg_emissions': 'ES GHG Emissions',
    't_total_contributing_area': 'ES Total contributing area',
    't_total_raw_material_usage': 'ES Total Raw Material Usage',
    't_sustainable_raw_material_usage': 'ES Sustainable Raw Material Usage',
    't_sustainable_raw_material_usage_share': 'ES Share of Sustainable Raw Material Usage',
    't_horizontal_artificialization': 'ES Horizontal Artificialisation',
    't_vertical_artificialization': 'ES Vertical Artificialisation',
    't_coverage_by_floorArea': 'ES Coverage by floor area',
    't_filename': 'ES File Name',
    't_document_type': 'ES Document Type',
    't_implementation_date': 'ES Implementation Date',
    't_date_of_upload': 'ES Date of Upload',
    't_uploaded_by': 'ES Uploaded by',
    't_fundname': 'ES Fund Name',
    't_document_size': 'ES Document Size',
    't_export_documents': 'ES Export documents',
    't_validation_errors': 'ES Record has validation errors',
    't_validation_warning': 'ES Record has warnings',
    't_validation_consumption_blank': 'ES Please enter consumption for this date range.',
    't_validation_consumption_specific': 'ES Please specify whether this consumption is estimated or actual.',
    't_validation_source': 'ES Please specify the origin of the consumption figure, for example invoice or meter reading.',
    't_validation_from_date_blank': 'ES Please enter from date.',
    't_validation_to_date_blank': 'ES Please enter to date.',
    't_validation_comment': 'ES This is now a required field, because you calculated an estimate for this consumption figure. Please explain the methodology behind your calculation.',
    't_validation_negative_not_allowed': 'ES SIERA cannot accept negative values. Please get in touch with our support team or adjust your consumption by pro-rating. {0}.',
    't_warning_consumption_inactive': 'ES You are submitting consumption for a meter that is tagged as inactive during this time period. Please check your dates are correct, and check the meter status is up to date.',
    't_warning_consumption_same_period': 'ES This consumption figure is +-10% for the same period in the previous year. Please check you have entered it correctly before proceeding, including decimal places and unit of measurement.',
    't_warning_consumption_same_diff_period': 'ES The exact consumption figure has been uploaded to a different meter before. Please check it is correct before proceeding.',
    't_validation_from_date_before_today': 'ES As you are submitting actual (not estimated) consumption, please select a date before today.',
    't_validation_from_date_lesser': 'ES From date should be less than or equal to To date.',
    't_validation_date_overlap': 'ES We already have consumption data for {0}. Please adjust your data to a new date range to avoid overlaps. {1}.',
    't_upload_nzc_top_down_pathways': 'ES Upload NZC Top-Down Pathway',
    't_upload_nzc_top_down_pathways_subtext': 'ES You can import up to 7 NZC Top-Down pathways simultaneously. In order to upload the pathway data to SIERA, the data needs to be in accordance with our data template. {0} about how to upload NZC Top-Down Pathways into Siera.',
    't_upload_nzc_top_down_pathways_point_one': 'ES Generate and populate your template',
    't_upload_nzc_top_down_pathways_point_one_subtext': 'ES Populate the template with your list of Pathways. The template has been partially populated to help you get the data in the right place.',
    't_upload_nzc_top_down_pathways_point_two': 'ES Upload NZC Top-Down pathways data',
    't_upload_nzc_top_down_pathways_point_two_subtext': 'ES When you upload your completed template, you will be guided through an error handling process.',
    't_actions_breakdown': 'ES Actions breakdown',
    't_filenames': 'ES File Name(s)',
    't_metername': 'ES Meter Name',
    't_select_the_status_of_asset': 'ES Please select a status for this asset.',
    't_to_tc': 'ES To',
    't_delete_document': 'ES Delete document',
    't_confirm_delete_document': 'ES Are you sure you want to delete this document?',
    't_confirm_delete_documents': 'ES Are you sure you want to delete these documents?',
    't_top_down_carbon_intensity': 'ES Top-Down Carbon intensity',
    't_top_down_energy_intensity': 'ES Top-Down Energy intensity',
    't_top_down_pathways_template_filename': 'ES Upload_NZC_TopDown_Pathways_Template',
    't_top_down_pathways_carbon_template_title': 'ES Uploading NZC Top Down Pathways - Carbon Intensity',
    't_top_down_pathways_energy_template_title': 'ES Uploading NZC Top Down Pathways - Energy Intensity',
    't_how_to_use_this_template': 'ES How to use this template',
    't_pathway_name': 'ES Pathway Name',
    't_pathway':'ES Pathway',
    't_top_down_template_instruction_1': 'ES This excel sheet is used to upload Top Down Pathways.',
    't_top_down_template_instruction_2': 'ES This sheet has rows where you enter the Pathway names - these are editable with a max character limit of 40.',
    't_top_down_template_instruction_3': 'ES You can only upload upto a maximum of 7 pathways (rows).',
    't_top_down_template_instruction_4': 'ES The columns indicate the Years, these are pre-selected from 2019-2050.',
    't_top_down_template_instruction_5': 'ES You can choose to enter in any cells under the year column (can also leave them blank).',
    't_top_down_template_instruction_6': 'ES You must enter numerical values in these cells.',
    't_top_down_template_instruction_7': 'ES Please make sure you know the units you are using from Siera.',
    't_previous_period_recycled': 'ES previous period (recycled)',
    't_sustainable_weight_greater_than_total_weight': 'Sustainable materials weight cannot be greater than the total weight',
    't_start_date_before_end_date': 'ES Start date must be before end date',
    't_total_missing_data': 'ES total missing data',
    't_filter_documents': 'ES Filter documents',
    't_filter_consumption_evidence': 'ES Filter consumption evidence',
    't_valid_within': 'ES Valid within',
    't_evidence_date_range': 'ES Evidence date range',
    't_pick_date_range': 'ES Pick a date range',
    't_pick_evidence_date_range': 'ES Pick evidence date range',
    't_doc_type': 'ES Document type',
    't_select_doc_type': 'ES Select document type',
    't_select_doc_fund': 'ES Select fund',
    't_select_asset': 'ES Select asset',
    't_select_doc_country': 'ES Select country',
    't_select_managing_agent': 'ES Select managing agent',
    't_select_user': 'ES Select user',
    't_search_fund': 'ES Search by fund name',
    't_search_asset': 'ES Search by asset name or asset ref',
    't_search_name': 'ES Search by name',
    't_search_document': 'ES Search by document name',
    't_search_country': 'ES Search by country name',
    't_select_meter': 'ES Select meter',
    't_search_meter': 'ES Search meter',
    't_search_sector': 'ES Search sector',
    't_assurance_doc': 'ES Assurance document',
    't_audit_report': 'ES Audit/Recommendations report',
    't_energy_rating_certificate': 'ES Energy rating certificate',
    't_fund_report': 'ES Fund reports',
    't_green_building_certificate': 'ES Green building certificate',
    't_sustainability_action_plan': 'ES Sustainability action plan',
    't_select_a_status': 'ES Select a status',
    't_remove_item': 'ES Remove item',
    't_add_new_record': 'ES Add new record',
    't_add_old_record': 'ES Add old record',
    't_select_date_error': 'ES Please select a date',
    't_date_set_automatically': 'ES This date is set automatically by the above item\'s Start date. This is to make sure there\'s no gaps or overlaps between items on the timeline.',
    't_present': 'ES Present',
    't_exposed': 'ES Exposed',
    't_not_exposed': 'ES Not exposed',
    't_renewable_energy_certificate':'ES Renewable energy certificate',
    't_expiry_date':'ES Expiry date',
    't_select_expiry_date':'ES Select expiry date',
    't_report_date':'ES Report date *',
    't_select_report_date':'ES Select a valid report date',
    't_record_type_document':'ES Which record type does this document belong to? *',
    't_select_record_type':'ES Select record type',
    't_select_document_type':'ES Select document type',
    't_drag_drop':'ES Drag and drop or',
    't_document_select_file':'ES Select file',
    't_document_export':'ES Document Export',
    't_add_document':'ES Add document',
    't_search_fund_ref':'ES Search by fund name',
    't_delete_top_down_pathway': 'ES Delete top-down pathway',
    't_delete_topdownpathway_confirm_text': 'ES Are you sure you want to delete this top-down pathway?',
    't_exposure':'ES Exposure',
    't_contract_status': 'ES Contract status',
    't_active': 'ES Active',
    't_inactive': 'ES Inactive',
    't_saved':'ES Saved',
    't_document_upload':'ES Document upload *',
    't_asset_reference_address': 'ES Asset Reference & Address',
    't_clear_filters':'ES Clear filters',
    't_variance_previous_period_or_target':'ES Variance from previous period or target',
    't_reports_assetplanningpermissiondate_not_found_msg': 'ES Planning Permission Date cannot be empty.',
    't_reports_gav_not_found_msg': 'ES GAV must be stated for the entirety of {reportingPeriod}.',
    't_reports_fossilfuelexposure_not_found_msg': 'ES Fossil Fuel Exposure must be stated for the entirety of {reportingPeriod}.',
    't_reports_wasteproduction_not_found_msg': 'ES Waste Contract status must be stated for the entirety of {reportingPeriod}.',
    't_reports_ped_not_found_msg': 'ES {fields} cannot be empty if planning permission was received after 31/12/2020.',
    't_reports_biodiversity_not_found_msg': 'ES {areas} cannot be empty.',
    't_top_down_pathway_success_message_one' : 'ES {0} NZC Top-Down pathways have been uploaded on your model.',
    't_top_down_pathway_success_message_one_single_pathway' : 'ES {0} NZC Top-Down pathway has been uploaded on your model.',
    't_top_down_pathway_success_message_two' : 'ES Your data will be available to view on your NZC model.',
    't_return_to_net_zero_carbon' : 'ES Return to Net Zero Carbon',
    't_save_document':'ES Save document',
    't_save_documents':'ES Save documents',
    't_edit_document':'ES Edit document',
    't_add_another_document':'ES Add another document',
    't_variance_explanation_title': 'ES Variance explanation',
    't_variance_explanation': 'ES Variance for a utility compared to the previous period, or to the target if one is set',
    't_add_new_document':'ES New document',
    't_update_document':'ES Update document',
    't_update_documents':'ES Update documents',
    't_document_updated':'ES Updated',
    't_target_variance': 'ES Target variance',
    't_period_variance': 'ES Period variance',
    't_landlord_data':'ES Landlord Data',
    't_tenant_procurement':'ES Tenant Procurement',
    't_planning_permission_before_year_built':'ES Planning Permission Date must be before the Year built.',
    't_impact_info': 'ES What does this action affect in overall regarding sustainablity',
    't_cost_type_info': 'ES Can the cost associated with actions be something that can be recovered',
    't_scope_info': 'ES Outlining which controlled areas in terms of utilities are affected independent if they are Landlord/Tenant controlled',
    't_gresb_info': 'ES Actions undertaken to reduce consumption and improve efficient use of utilities as a sustainable resource',
    't_payback_period_info': 'ES Time required to recoup the cost of action via the savings generated through its investment',
    't_effect_utilities': 'ES The savings per utility type and its cost. Negative value shows greater savings/reduction and Positive shows an increase',
    't_utility_consumption_year': 'ES Utility consumption per year',
    't_utility_cost_year': 'ES Utility cost per year',
    't_utility_consumption_year_info': 'ES <info_title>Utility consumption after implementing action.</info_title>{0} {1}',
    't_utility_cost_year_info': 'ES <info_title>Costs per year of running the utility after implementing action.</info_title>{0} {1}',
    't_tenant_controlled': 'ES Tenant controlled',
    't_landlord_controlled': 'ES Landlord controlled',
    't_cannot_be_empty':'ES This field cannot be empty',
    't_add_asset_success': 'ES Asset has been created',
    't_add_asset_summary': 'ES Everyone within the fund will have access. To provide non-fund-level users access, go to user permissions.',
    't_edit_asset_title': 'ES Asset has been updated',
    't_edit_asset_summary': 'ES Updates across all modules will be reflected shortly.',
    't_select_framework': 'ES Select a framework',
    't_utility_per_year': 'ES Utility per year',
    't_cost_per_year': 'ES Cost per year',
    't_utility_per_year_info_content_one': 'ES 1000 {0} = 1000 {1} increase over a year',
    't_utility_per_year_info_content_two': 'ES -1000 {0} = 1000 {1} decrease over a year',
    't_cost_per_year_info_content_one': 'ES {0}100/yr = {0}100 increase in cost per year',
    't_cost_per_year_info_content_two': 'ES -{0}100/yr = {0}100 decrease in cost per year',
    't_year_dynamic': 'ES Year {year}',
    't_ped_tooltip_content': 'ES An asset’s Primary Energy Demand (PED) models the amount of energy which must be extracted from primary sources to supply the asset’s typical energy usage, and can often be found on an EPC.',
    't_nzeb_tooltip_content': 'ES The NZEB Threshold is the energy performance target an asset must meet to qualify as a Nearly Zero-Energy Building, calculated according to the appropriate national methodology. Non-EU nations will not have an applicable NZEB threshold.',
    't_sustainable_tonnes_tooltip_content': 'ES Sustainably sourced refers to materials which are recovered, recycled or bio-sourced.',
    't_horizontal_artificial_tooltip_content': 'ES The amount of plan or “bird’s eye” surface area which is non-vegetated.',
    't_total_horizontal_tooltip_content': 'ES The total plan or “bird’s eye” surface area of the asset.',
    't_vertical_artificial_tooltip_content': 'ES The amount of external, vertical surface area which is non-vegetated.',
    't_total_vertical_tooltip_content': 'ES The total external, vertical surface area of the asset.',
    't_click_to_read': 'ES Click here to read more',
    't_reporting_years': 'ES Reporting Years',
    't_data_readiness': 'ES Data Readiness',
    't_waste_contract_status': 'ES Waste Contract Status',
    't_evaluation_date': 'ES Evaluation Date',
    't_add_new_status': 'ES Add new status',
    't_add_historic_status': 'ES Add historic status',
    't_add_new_exposure': 'ES Add new exposure',
    't_add_historic_exposure': 'ES Add historic exposure',
    't_siera_version': 'ES SIERA version',
    't_renewables': 'ES Renewables',
    't_on_site_generation': 'ES On-site generation',
    't_gia_percentage': 'ES {0}% of your GIA {1}',
    't_assets_count': 'ES {0} assets',
    't_self_consumption': 'ES {0}% Self consumption',
    't_export_to_grid': 'ES {0}% Exported to grid',
    't_contribution_electricity_consumption': 'ES {0}% Contribution to electricity consumption',
    't_on_site_generated': 'ES {0}% On site generated',
    't_off_site_purchased': 'ES {0}% Off-site purchased',
    't_non_renewables': 'ES {0}% Non-renewables',
    't_renewables_floor_area': 'ES Renewables floor area',
    't_renewables_floor_area_info': 'ES This percentage is calculated via the number of asset count with on site generation weighted by the floor area',
    't_detailed_renewables_soon': 'ES Detailed performance view for Renewables coming soon.',
    't_record_type_asset_document':'ES Which asset does this document belong to? *',
    't_valid_from_document':'ES Valid from date *',
    't_expiry_date_mandatory':'ES Expiry date *',
    't_end_date_after_start_date': 'ES End date must be after start date',
    't_action_deleted': 'ES Action successfully deleted',
    't_action_deleted_content': 'ES ‘{0}’ action has been deleted by {1}',
    't_select_agent': 'ES Select Agent',
    't_supplier_estimate': 'ES Supplier estimate',
    't_calculated_estimate': 'ES Calculated estimate',
    't_dq_total_asset_floor_area': 'ES Total Asset Floor Area',
    't_floor_area_unaccounted_for': 'ES Floor area unaccounted for',
    't_action_name_exists': 'ES Action name must be unique for the selected asset',
    't_managing_agent_upper_case': 'ES Managing Agent',
    't_data_coverage' : 'ES Data coverage',
    't_data_completeness': 'ES Data completeness',
    't_fund_data_coverage': '<p><b>ES Floor area coverage:</b> Where we have information about meters in a given part of the building for a given utility.</p> <p><b>Floor area unaccounted for: </b> Where we have no information about meters in a given part of a building for a given utility, but we believe this utility is being consumed (this is a measure of floor area). These areas are always assumed to be tenant-procured rather than landlord-procured, except for landlord-controlled assets where no meters have been added.</p>',
    't_fund_data_completeness': '<p><b>ES Actual:</b> Consumption data entered for a meter.</p> <p><b>Supplier estimate:</b> Meter data derived from supplier estimates (e.g. from invoices). These should be treated as actual data for reporting purposes, but they are still less accurate for precise performance monitoring.</p> <p><b>Calculated estimate:</b> Meter data derived from calculated estimates (e.g. calculated by an EVORA consultant using an accepted methodology).</p> <p><b>Missing:</b> Where a meter for a building area has been set up but is missing data for one or more time periods (this is a measure of time).</p>',
    't_add_new_evaluation': 'ES Add new Evaluation',
    't_add_new_occupancy': 'ES Add new Occupancy',
    't_documents_space_exceed':'ES You have exceeded your organisation\'s maximum storage capacity. To upload this document, please {0} to increase your storage limit.',
    't_data_category' : 'ES Data Category',
    't_supplier': 'ES Supplier',
    't_area_served': 'ES Floor Area Served',
    't_add_consumption': 'ES Add consumption',
    't_all_data_categories': 'ES All data categories',
    't_agreed_actions_count_nzc':'ES {0} Agreed actions',
    't_applicable_actions_count_nzc':'ES {0} Applicable actions',
    't_stranding_year_year': 'ES {0} (CRREM Misalignment year)',
    't_not_stranding': 'ES Not CRREM Misaligned',
    't_actions_pathway_recommended': 'ES Actions pathway (recommended)',
    't_actions_pathway_optional': 'ES Actions pathway (optional)',
    't_agreed_actions_pathway': 'ES Agreed actions pathway',
    't_applicable_actions_pathway': 'ES Applicable actions pathway',
    't_bau_pathway': 'ES Business as usual pathway',
    't_fund_view': 'ES Fund view',
    't_assets_list': 'ES Assets list',
    't_chart_specification': 'ES Chart specification',
    't_chart_preconfigured': 'ES This chart has been preconfigured to display:',
    't_grid_decarbonisation_toast': '- ES Grid decarbonisation',
    't_sbt_toast': '- ES Science based target (1.5C)',
    't_bau_toast': '- ES Business as Usual',
    't_agreed_actions_toast': '- ES Agreed Action based pathways',
    't_reporting_year_value': 'ES Reporting year: {0}',
    't_cost_intensity_value': 'ES {0} GBP/m²/yr',
    't_energy_intensity_value': 'ES {0} kWh/m²/yr',
    't_carbon_intensity_value': 'ES {0} kgCO₂e/m²/yr',
    't_co2_emissions_value': 'ES {0} tCO₂e/yr',
    't_data_coverage_percentage_value' : 'ES {0}% Data coverage',
    't_origin_meter_reading': 'ES Meter reading',
    't_origin_invoice': 'ES Invoice',
    't_origin_amr': 'ES AMR',
    't_actual_data': 'ES Actual data',
    'jv_between_funds': 'ES Joint venture between funds:',
    't_meter_inactive_sold': 'ES Meter was inactive or asset was not owned during this month',
    't_coverage': 'ES Coverage',
    't_completeness': 'ES Completeness',
    't_total_asset_floor_gia': 'ES Total asset floor area',
    't_expiry_date_must_be_after_report_date': 'ES Expiry date must be after report date',
    't_unique_file_name': 'ES A file with this name already exists',
    't_special_character': 'ES File name can\'t contain any of the following [ ] # * = / : \\ \' " | , < > & ?',
    't_special_character_comment': 'ES Comment can\'t contain special characters',
    't_custom': 'ES Custom'
  }
}